import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AdminDto = {
  __typename?: 'AdminDto';
  avatar?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  phoneExt?: Maybe<Scalars['Int']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
};

export type AdminType = {
  __typename?: 'AdminType';
  avatar: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CalculationRequestInput = {
  birthDate: Scalars['String']['input'];
  coverages: Array<Scalars['String']['input']>;
  maxPrice?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type CalculationResponseDto = {
  __typename?: 'CalculationResponseDto';
  actionLabel?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  calculatorConfig?: Maybe<CalculatorProductConfigDto>;
  calculatorFilterProperties?: Maybe<Array<CalculatorFilterPropertyDto>>;
  code: Scalars['String']['output'];
  coverages?: Maybe<Array<CalculatorCoverageWithPriceDto>>;
  detailsLink?: Maybe<Scalars['String']['output']>;
  diffPrice?: Maybe<Scalars['Float']['output']>;
  fixedCoverages?: Maybe<Array<CalculatorFixedCoverageDto>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  premiumEligibleAgeMax?: Maybe<Scalars['Int']['output']>;
  premiumEligibleAgeMin?: Maybe<Scalars['Int']['output']>;
  priceWithoutDiscounts: Scalars['Float']['output'];
  prices: ProductCalculationPricesDto;
  visual?: Maybe<CalculatorProductVisualDto>;
};

export type CalculatorCoverageWithPriceDto = {
  __typename?: 'CalculatorCoverageWithPriceDto';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  editOnWeb?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CalculatorFilterPropertyDto = {
  __typename?: 'CalculatorFilterPropertyDto';
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type CalculatorFixedCoverageDto = {
  __typename?: 'CalculatorFixedCoverageDto';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type CalculatorProductConfigDto = {
  __typename?: 'CalculatorProductConfigDto';
  calculationCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  disabled: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  visual?: Maybe<CalculatorProductVisualDto>;
  webservice: Scalars['Boolean']['output'];
};

export type CalculatorProductVisualDto = {
  __typename?: 'CalculatorProductVisualDto';
  description: Scalars['String']['output'];
  discount: Array<Scalars['String']['output']>;
  highlight: Scalars['Boolean']['output'];
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type CallMeInput = {
  number: Scalars['String']['input'];
  product: Scalars['String']['input'];
  soId?: InputMaybe<Scalars['String']['input']>;
};

export type CheckoutHealthOfferDataInput = {
  contractor: HealthOfferDataContractorInput;
  delivery: HealthOfferDataDeliveryInput;
  insuredPerson: HealthOfferDataInsuredPersonInput;
  offerId: Scalars['String']['input'];
};

export type CheckoutHealthOfferDto = {
  __typename?: 'CheckoutHealthOfferDto';
  _id: Scalars['String']['output'];
  acceptedEmailDocumentationDeliveryAt?: Maybe<Scalars['String']['output']>;
  additional?: Maybe<HealthOfferBranchDto>;
  allianzGDPRAcceptedAt?: Maybe<Scalars['String']['output']>;
  annotations?: Maybe<Array<Scalars['String']['output']>>;
  brandId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  funnel?: Maybe<HealthOfferFunnelDto>;
  iddTermsAcceptedAt?: Maybe<Scalars['String']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  offerLink?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  soId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  supplementary?: Maybe<HealthOfferBranchDto>;
  termsAcceptedAt?: Maybe<Scalars['String']['output']>;
  total?: Maybe<HealthOfferTotalDto>;
};

export type ConsentInput = {
  consent?: InputMaybe<Array<HealthConsentInput>>;
  offerId: Scalars['String']['input'];
};

export type ContractorInput = {
  contractor?: InputMaybe<ContractorPartInput>;
  delivery?: InputMaybe<DeliveryInput>;
  insuredPerson?: InputMaybe<InsuredPersonInput>;
};

export type ContractorPartInput = {
  asEntity?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oib?: InputMaybe<Scalars['String']['input']>;
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOfferInput = {
  coverages: Array<Scalars['String']['input']>;
  productCode: Scalars['String']['input'];
};

export type CreateSoInput = {
  additionalInsuranceInfo?: InputMaybe<SoHealthAdditionalInfoInput>;
  cancellationDate?: InputMaybe<Scalars['String']['input']>;
  crossSell?: InputMaybe<CrossSellInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  diffPrice?: InputMaybe<Scalars['Float']['input']>;
  drugList?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasBList?: InputMaybe<Scalars['Boolean']['input']>;
  hasPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  partnerSource?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  productTypeCode?: InputMaybe<Scalars['String']['input']>;
  soId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  visitorIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrossSellInput = {
  adminId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  productTypeCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CrossSellSource>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** Source of the cross-sell */
export enum CrossSellSource {
  GeneralSo = 'GENERAL_SO',
  KompareOffer = 'KOMPARE_OFFER',
  SellingOpportunity = 'SELLING_OPPORTUNITY'
}

export type DeliveryEntityEditableValue = {
  __typename?: 'DeliveryEntityEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type DeliveryInput = {
  asEntity?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  isRegularDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Float']['input']>;
};

export type FunnelStepType = {
  __typename?: 'FunnelStepType';
  code: Scalars['String']['output'];
  openedAt: Scalars['String']['output'];
};

export type FunnelType = {
  __typename?: 'FunnelType';
  latestStep: Scalars['String']['output'];
  steps: Array<FunnelStepType>;
};

export type GenderEditableValue = {
  __typename?: 'GenderEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GeneralTransferDetailsInput = {
  installments: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type GeneralTransferInfo = {
  __typename?: 'GeneralTransferInfo';
  customerAddress: Scalars['String']['output'];
  customerCity: Scalars['String']['output'];
  customerCountry: Scalars['String']['output'];
  customerEmail?: Maybe<Scalars['String']['output']>;
  customerFirstName: Scalars['String']['output'];
  customerLastName: Scalars['String']['output'];
  customerOib: Scalars['String']['output'];
  customerPhone?: Maybe<Scalars['String']['output']>;
  customerZipCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  model: Scalars['String']['output'];
  numberOfInstallments?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  recipientAccountNumber: Scalars['String']['output'];
  recipientAddress: Scalars['String']['output'];
  recipientCity: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  recipientZipCode: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  referenceNumberType: Scalars['String']['output'];
  referencePrefix: Scalars['String']['output'];
  referenceSuffix: Scalars['String']['output'];
};

export type GetOfferDto = {
  __typename?: 'GetOfferDto';
  _id: Scalars['String']['output'];
  acceptedEmailDocumentationDeliveryAt?: Maybe<Scalars['String']['output']>;
  brandId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  funnel?: Maybe<OfferFunnelType>;
  iddTermsAcceptedAt?: Maybe<Scalars['String']['output']>;
  paymentErrors?: Maybe<Array<OfferPaymentErrorType>>;
  product?: Maybe<OfferProductType>;
  productTypeSpecific?: Maybe<OfferProductTypeSpecificType>;
  soId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  termsAcceptedAt?: Maybe<Scalars['String']['output']>;
};

export type GetSoDto = {
  __typename?: 'GetSoDto';
  _id: Scalars['String']['output'];
  admin?: Maybe<AdminType>;
  email: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  funnel?: Maybe<FunnelType>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  productTypeId: ProductTypeGraphQl;
  productTypeSpecific?: Maybe<ProductTypeSpecificType>;
  soNumber: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GetWspayPaymentDataInput = {
  installment: Scalars['Int']['input'];
  paymentOption: Scalars['String']['input'];
  paymentType: Scalars['String']['input'];
};

export type HealthConsentInput = {
  CarGiveAway?: InputMaybe<Scalars['Boolean']['input']>;
  allianzGDPR?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  fourteenDayCancellationPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  generalTOSConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthEmailDocumentationConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthNeedConsent?: InputMaybe<Scalars['Boolean']['input']>;
  healthValidDataConsent?: InputMaybe<Scalars['Boolean']['input']>;
  kompareHelp?: InputMaybe<Scalars['Boolean']['input']>;
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  newsletterSpecialOffers?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HealthOfferBranchDto = {
  __typename?: 'HealthOfferBranchDto';
  actionLabel?: Maybe<Scalars['String']['output']>;
  additionalCoverages?: Maybe<Array<HealthOfferIncludedItemDto>>;
  baseProductPrice?: Maybe<Scalars['Float']['output']>;
  brandCode?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<HealthOfferCoverageDto>>;
  discounts?: Maybe<Array<HealthOfferDiscountDto>>;
  fixedCoverages?: Maybe<Array<HealthOfferCoverageDto>>;
  includedInPrice?: Maybe<Array<HealthOfferIncludedItemDto>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  numberOfInstallments?: Maybe<Scalars['Int']['output']>;
  paymentSlipInfo?: Maybe<HealthOfferPaymentSlipInfoDto>;
  priceChangeModifier?: Maybe<HealthOfferPriceChangeModifierDto>;
  total?: Maybe<HealthOfferTotalDto>;
  visual?: Maybe<HealthOfferVisualDto>;
  voucherPriceChangeModifier?: Maybe<HealthOfferVoucherPriceChangeModifierDto>;
  voucherPriceModifier?: Maybe<HealthOfferVoucherPriceModifierDto>;
};

export type HealthOfferCoverageDto = {
  __typename?: 'HealthOfferCoverageDto';
  description?: Maybe<Scalars['String']['output']>;
  gratis?: Maybe<HealthOfferGratisDto>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<HealthOfferCoverageOptionDto>>;
  price?: Maybe<Scalars['Float']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferCoverageOptionDto = {
  __typename?: 'HealthOfferCoverageOptionDto';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferData = {
  __typename?: 'HealthOfferData';
  collectContractorPhone?: Maybe<Scalars['Boolean']['output']>;
  contractor?: Maybe<HealthOfferDataContractor>;
  delivery?: Maybe<HealthOfferDataDelivery>;
  hasPolicy?: Maybe<Scalars['Boolean']['output']>;
  insuredPerson?: Maybe<HealthOfferDataInsuredPerson>;
  karenca?: Maybe<Scalars['Boolean']['output']>;
  newPolicyStartDate?: Maybe<Scalars['String']['output']>;
  newPolicyStartDateNote?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  termsDocuments?: Maybe<Array<HealthOfferTermsDocument>>;
  termsLink?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferDataContractor = {
  __typename?: 'HealthOfferDataContractor';
  company?: Maybe<HealthOfferDataContractorCompany>;
  isSamePerson?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<HealthOfferDataContractorPerson>;
  personType?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferDataContractorCompany = {
  __typename?: 'HealthOfferDataContractorCompany';
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  companyName?: Maybe<StringEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  phoneNumber?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataContractorCompanyInput = {
  city: Scalars['String']['input'];
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  houseNumber: Scalars['String']['input'];
  oib: Scalars['String']['input'];
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetAndHouseNumber: Scalars['String']['input'];
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['Int']['input'];
};

export type HealthOfferDataContractorInput = {
  company?: InputMaybe<HealthOfferDataContractorCompanyInput>;
  isSamePerson: Scalars['Boolean']['input'];
  person?: InputMaybe<HealthOfferDataContractorPersonInput>;
  personType: Scalars['String']['input'];
};

export type HealthOfferDataContractorPerson = {
  __typename?: 'HealthOfferDataContractorPerson';
  birthDate?: Maybe<StringEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  firstName?: Maybe<StringEditableValue>;
  gender?: Maybe<GenderEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  lastName?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  phoneNumber?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataContractorPersonInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oib?: InputMaybe<Scalars['String']['input']>;
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthOfferDataDelivery = {
  __typename?: 'HealthOfferDataDelivery';
  asEntity?: Maybe<DeliveryEntityEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  name?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataDeliveryInput = {
  asEntity: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type HealthOfferDataInsuredPerson = {
  __typename?: 'HealthOfferDataInsuredPerson';
  birthDate?: Maybe<StringEditableValue>;
  city?: Maybe<StringEditableValue>;
  cityKompareId?: Maybe<StringEditableValue>;
  firstName?: Maybe<StringEditableValue>;
  gender?: Maybe<GenderEditableValue>;
  houseNumber?: Maybe<StringEditableValue>;
  insuranceNumber?: Maybe<StringEditableValue>;
  lastName?: Maybe<StringEditableValue>;
  oib?: Maybe<StringEditableValue>;
  partnerContactEmail?: Maybe<StringEditableValue>;
  personalIdIssuer?: Maybe<StringEditableValue>;
  personalIdNumber?: Maybe<StringEditableValue>;
  phoneNumber?: Maybe<StringEditableValue>;
  street?: Maybe<StringEditableValue>;
  streetAndHouseNumber?: Maybe<StringEditableValue>;
  streetKompareId?: Maybe<StringEditableValue>;
  zipCode?: Maybe<IntEditableValue>;
};

export type HealthOfferDataInsuredPersonInput = {
  city: Scalars['String']['input'];
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber: Scalars['String']['input'];
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  oib: Scalars['String']['input'];
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  personalIdIssuer?: InputMaybe<Scalars['String']['input']>;
  personalIdNumber?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['Int']['input'];
};

export type HealthOfferDiscountDto = {
  __typename?: 'HealthOfferDiscountDto';
  tooltip?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferFunnelDto = {
  __typename?: 'HealthOfferFunnelDto';
  latestStep?: Maybe<HealthOfferFunnelStepDto>;
  steps?: Maybe<Array<HealthOfferFunnelStepDto>>;
};

export type HealthOfferFunnelStepDto = {
  __typename?: 'HealthOfferFunnelStepDto';
  code: Scalars['String']['output'];
  openedAt: Scalars['String']['output'];
};

export type HealthOfferGratisDto = {
  __typename?: 'HealthOfferGratisDto';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type HealthOfferIncludedItemDto = {
  __typename?: 'HealthOfferIncludedItemDto';
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** Single installment line for a payment type */
export type HealthOfferPaymentInstallment = {
  __typename?: 'HealthOfferPaymentInstallment';
  amount: Scalars['Float']['output'];
  installment: Scalars['Int']['output'];
  paymentTypeDiscount: Scalars['Float']['output'];
};

/** Grouped option (credit card, transfer, keksPay, …) */
export type HealthOfferPaymentOption = {
  __typename?: 'HealthOfferPaymentOption';
  paymentOption: Scalars['String']['output'];
  paymentSlipInfo?: Maybe<HealthOfferPaymentSlipInfo>;
  paymentTypes: Array<HealthOfferPaymentType>;
};

/** Payment slip metadata shown on transfer-method rows */
export type HealthOfferPaymentSlipInfo = {
  __typename?: 'HealthOfferPaymentSlipInfo';
  amount?: Maybe<Scalars['Float']['output']>;
  numOfInstallments?: Maybe<Scalars['Int']['output']>;
};

export type HealthOfferPaymentSlipInfoDto = {
  __typename?: 'HealthOfferPaymentSlipInfoDto';
  amount?: Maybe<Scalars['Float']['output']>;
  numOfInstallments?: Maybe<Scalars['Int']['output']>;
};

/** Card / transfer method under a payment option */
export type HealthOfferPaymentType = {
  __typename?: 'HealthOfferPaymentType';
  installments: Array<HealthOfferPaymentInstallment>;
  paymentType: Scalars['String']['output'];
  paymentTypeLabel: Scalars['String']['output'];
};

export type HealthOfferPriceChangeModifierDto = {
  __typename?: 'HealthOfferPriceChangeModifierDto';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferTermsDocument = {
  __typename?: 'HealthOfferTermsDocument';
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type HealthOfferTotalDto = {
  __typename?: 'HealthOfferTotalDto';
  creditCard?: Maybe<Scalars['Float']['output']>;
  creditCardWithInstallments?: Maybe<Scalars['Float']['output']>;
  generalTransfer?: Maybe<Scalars['Float']['output']>;
  generalTransferWithInstallments?: Maybe<Scalars['Float']['output']>;
};

export type HealthOfferVisualDto = {
  __typename?: 'HealthOfferVisualDto';
  description?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferVoucherPriceChangeModifierDto = {
  __typename?: 'HealthOfferVoucherPriceChangeModifierDto';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type HealthOfferVoucherPriceModifierDto = {
  __typename?: 'HealthOfferVoucherPriceModifierDto';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type HealthQuestionnaireAnswerItemInput = {
  followUpAnswers?: InputMaybe<Array<HealthQuestionnaireFollowUpAnswerInput>>;
  questionCode: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type HealthQuestionnaireFollowUpAnswerInput = {
  fieldCode: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type InsuredPersonInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  cityKompareId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oib?: InputMaybe<Scalars['String']['input']>;
  partnerContactEmail?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<Scalars['String']['input']>;
  personalIdIssuer?: InputMaybe<Scalars['String']['input']>;
  personalIdNumber?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetAndHouseNumber?: InputMaybe<Scalars['String']['input']>;
  streetKompareId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type IntEditableValue = {
  __typename?: 'IntEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms?: Maybe<Scalars['String']['output']>;
  callMe: Scalars['String']['output'];
  checkAndApplyVoucherCode?: Maybe<CheckoutHealthOfferDto>;
  checkoutPaymentErrors?: Maybe<Scalars['String']['output']>;
  createHealthOffer?: Maybe<Scalars['String']['output']>;
  createSo: Scalars['String']['output'];
  paymentAttempt?: Maybe<Scalars['String']['output']>;
  removeVoucherCode?: Maybe<CheckoutHealthOfferDto>;
  saveAndSubmitHealthQuestionnaireForAdmin: SubmitHealthQuestionnaireResponseDto;
  saveConsent: Scalars['Boolean']['output'];
  saveHealthQuestionnaireAnswers: Scalars['String']['output'];
  savePolicyCancellation: Scalars['Boolean']['output'];
  selectOffer: Scalars['String']['output'];
  sendGeneralTransferDetails?: Maybe<Scalars['String']['output']>;
  sendOffersToEmail: Scalars['Boolean']['output'];
  sendPolicyCancelationEmail: Scalars['Boolean']['output'];
  sendTermsAndConditionsToEmail?: Maybe<Scalars['String']['output']>;
  setContractor: Scalars['String']['output'];
  setInsuranceNumber: Scalars['Boolean']['output'];
  setWsPayCallbackResponse?: Maybe<Scalars['String']['output']>;
  setWsPayResponse?: Maybe<Scalars['String']['output']>;
  submitHealthQuestionnaire: SubmitHealthQuestionnaireResponseDto;
  updateCheckoutHealthOfferData: Scalars['Boolean']['output'];
};


export type MutationAcceptTermsArgs = {
  id: Scalars['String']['input'];
  input: TermsInput;
};


export type MutationCallMeArgs = {
  input: CallMeInput;
};


export type MutationCheckAndApplyVoucherCodeArgs = {
  offerId: Scalars['String']['input'];
  voucherCode: Scalars['String']['input'];
};


export type MutationCheckoutPaymentErrorsArgs = {
  id: Scalars['String']['input'];
  input: PaymentErrorInput;
};


export type MutationCreateHealthOfferArgs = {
  id: Scalars['String']['input'];
  input: CreateOfferInput;
};


export type MutationCreateSoArgs = {
  input: CreateSoInput;
};


export type MutationPaymentAttemptArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveVoucherCodeArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationSaveAndSubmitHealthQuestionnaireForAdminArgs = {
  adminId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  input: SaveHealthQuestionnaireAnswersInput;
};


export type MutationSaveConsentArgs = {
  params: ConsentInput;
};


export type MutationSaveHealthQuestionnaireAnswersArgs = {
  id: Scalars['String']['input'];
  input: SaveHealthQuestionnaireAnswersInput;
};


export type MutationSavePolicyCancellationArgs = {
  cancellationDate?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mimeType?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSelectOfferArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendGeneralTransferDetailsArgs = {
  id: Scalars['String']['input'];
  input: GeneralTransferDetailsInput;
};


export type MutationSendOffersToEmailArgs = {
  soId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendPolicyCancelationEmailArgs = {
  soId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSendTermsAndConditionsToEmailArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetContractorArgs = {
  id: Scalars['String']['input'];
  input: ContractorInput;
  offerId: Scalars['String']['input'];
};


export type MutationSetInsuranceNumberArgs = {
  id: Scalars['String']['input'];
  insuranceNumber: Scalars['String']['input'];
};


export type MutationSetWsPayCallbackResponseArgs = {
  id: Scalars['String']['input'];
  input: WsPayResponseInput;
};


export type MutationSetWsPayResponseArgs = {
  id: Scalars['String']['input'];
  input: WsPayResponseInput;
};


export type MutationSubmitHealthQuestionnaireArgs = {
  flow: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateCheckoutHealthOfferDataArgs = {
  params: CheckoutHealthOfferDataInput;
};

export type OfferAdditionalCalculatedType = {
  __typename?: 'OfferAdditionalCalculatedType';
  baseProductPrice?: Maybe<Scalars['Float']['output']>;
  coverages?: Maybe<OfferCalculatedPricesCoveragesType>;
  total?: Maybe<OfferTotalPriceType>;
};

export type OfferAdditionalType = {
  __typename?: 'OfferAdditionalType';
  code?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<OfferCoverageEntryType>>;
  gratis?: Maybe<OfferGratisType>;
  priceChangeModifier?: Maybe<OfferPriceModifierType>;
  voucherPriceChangeModifier?: Maybe<OfferVoucherPriceChangeModifierType>;
  voucherPriceModifier?: Maybe<OfferVoucherPriceModifierType>;
};

export type OfferBrandType = {
  __typename?: 'OfferBrandType';
  code: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shortName: Scalars['String']['output'];
};

export type OfferCalculatedPricesCoveragesType = {
  __typename?: 'OfferCalculatedPricesCoveragesType';
  additionalDailyHospitalAllowance?: Maybe<OfferCoveragePriceType>;
};

export type OfferCalculatedPricesType = {
  __typename?: 'OfferCalculatedPricesType';
  additional?: Maybe<OfferAdditionalCalculatedType>;
  supplementary?: Maybe<OfferSupplementaryCalculatedType>;
  total?: Maybe<OfferTotalPriceType>;
};

export type OfferContractorType = {
  __typename?: 'OfferContractorType';
  asEntity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityKompareId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  isSamePerson?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
  partnerContactEmail?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  streetKompareId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['Int']['output']>;
};

export type OfferCoverageEntryType = {
  __typename?: 'OfferCoverageEntryType';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gratis?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  price?: Maybe<Scalars['Float']['output']>;
};

export type OfferCoveragePriceType = {
  __typename?: 'OfferCoveragePriceType';
  amount?: Maybe<Scalars['Float']['output']>;
  multiplier?: Maybe<Scalars['Float']['output']>;
};

export type OfferDeliveryType = {
  __typename?: 'OfferDeliveryType';
  asEntity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityKompareId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  isRegularDelivery?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  streetKompareId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['Int']['output']>;
};

export type OfferFunnelStepType = {
  __typename?: 'OfferFunnelStepType';
  code: Scalars['String']['output'];
  openedAt: Scalars['String']['output'];
};

export type OfferFunnelType = {
  __typename?: 'OfferFunnelType';
  latestStep?: Maybe<OfferFunnelStepType>;
  steps: Array<OfferFunnelStepType>;
};

export type OfferGratisType = {
  __typename?: 'OfferGratisType';
  additionalSecondOpinion?: Maybe<Scalars['String']['output']>;
};

export type OfferHealthQuestionnaireAnswerType = {
  __typename?: 'OfferHealthQuestionnaireAnswerType';
  followUpAnswers?: Maybe<Array<OfferHealthQuestionnaireFollowUpAnswerType>>;
  questionCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OfferHealthQuestionnaireFollowUpAnswerType = {
  __typename?: 'OfferHealthQuestionnaireFollowUpAnswerType';
  fieldCode: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OfferHealthQuestionnaireMessageType = {
  __typename?: 'OfferHealthQuestionnaireMessageType';
  message: Scalars['String']['output'];
  ruleCode: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OfferHealthQuestionnaireType = {
  __typename?: 'OfferHealthQuestionnaireType';
  answers: Array<OfferHealthQuestionnaireAnswerType>;
  brandCode: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  isConfirmed?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<OfferHealthQuestionnaireMessageType>>;
  rejected?: Maybe<Scalars['Boolean']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
};

export type OfferInsuredPersonDetailsType = {
  __typename?: 'OfferInsuredPersonDetailsType';
  asEntity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityKompareId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  importantNote?: Maybe<Scalars['String']['output']>;
  insuranceNumber?: Maybe<Scalars['String']['output']>;
  karenca?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  newPolicyStartDate?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
  partnerContactEmail?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  streetKompareId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['Int']['output']>;
};

export type OfferPaymentErrorType = {
  __typename?: 'OfferPaymentErrorType';
  createdAt?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
};

export type OfferPaymentOptions = {
  __typename?: 'OfferPaymentOptions';
  offer?: Maybe<CheckoutHealthOfferDto>;
  paymentOptions: Array<HealthOfferPaymentOption>;
};

export type OfferPriceModifierType = {
  __typename?: 'OfferPriceModifierType';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OfferProductType = {
  __typename?: 'OfferProductType';
  annotations: Array<Scalars['String']['output']>;
  brand: OfferBrandType;
  code: Scalars['String']['output'];
  fixedCoverages?: Maybe<Array<OfferCoverageEntryType>>;
  name: Scalars['String']['output'];
  premiumEligibleAgeMax: Scalars['Int']['output'];
  premiumEligibleAgeMin: Scalars['Int']['output'];
};

export type OfferProductTypeSpecificType = {
  __typename?: 'OfferProductTypeSpecificType';
  additional?: Maybe<OfferAdditionalType>;
  calculatedPrices?: Maybe<OfferCalculatedPricesType>;
  contractor?: Maybe<OfferContractorType>;
  delivery?: Maybe<OfferDeliveryType>;
  healthQuestionnaire?: Maybe<OfferHealthQuestionnaireType>;
  insuredPerson?: Maybe<OfferInsuredPersonDetailsType>;
  paidAt?: Maybe<Scalars['String']['output']>;
  shoppingCartId: Scalars['Int']['output'];
  supplementary?: Maybe<OfferSupplementaryType>;
};

export type OfferSupplementaryCalculatedType = {
  __typename?: 'OfferSupplementaryCalculatedType';
  baseProductPrice?: Maybe<Scalars['Float']['output']>;
  coverages?: Maybe<OfferCalculatedPricesCoveragesType>;
  total?: Maybe<OfferTotalPriceType>;
};

export type OfferSupplementaryType = {
  __typename?: 'OfferSupplementaryType';
  actionLabel?: Maybe<Scalars['String']['output']>;
  brandCode?: Maybe<Scalars['String']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  coverages?: Maybe<Array<OfferCoverageEntryType>>;
  label?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  numberOfInstallments?: Maybe<Scalars['Float']['output']>;
  priceChangeModifier?: Maybe<OfferPriceModifierType>;
  voucherPriceChangeModifier?: Maybe<OfferVoucherPriceChangeModifierType>;
  voucherPriceModifier?: Maybe<OfferVoucherPriceModifierType>;
};

export type OfferTermsAndConditionsDocumentDto = {
  __typename?: 'OfferTermsAndConditionsDocumentDto';
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type OfferTermsAndConditionsGetDto = {
  __typename?: 'OfferTermsAndConditionsGetDto';
  brandCode: Scalars['String']['output'];
  brandName: Scalars['String']['output'];
  documents: Array<OfferTermsAndConditionsDocumentDto>;
  logoUrl: Scalars['String']['output'];
};

export type OfferTotalPriceType = {
  __typename?: 'OfferTotalPriceType';
  creditCard?: Maybe<Scalars['Float']['output']>;
  creditCardWithInstallments?: Maybe<Scalars['Float']['output']>;
  generalTransfer?: Maybe<Scalars['Float']['output']>;
  generalTransferWithInstallments?: Maybe<Scalars['Float']['output']>;
};

export type OfferVoucherPriceChangeModifierType = {
  __typename?: 'OfferVoucherPriceChangeModifierType';
  amount?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OfferVoucherPriceModifierType = {
  __typename?: 'OfferVoucherPriceModifierType';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type OverflowVoucherStatus = {
  __typename?: 'OverflowVoucherStatus';
  active: Scalars['Boolean']['output'];
  voucherCode: Scalars['String']['output'];
  voucherDescription: Scalars['String']['output'];
  voucherValue: Scalars['Float']['output'];
};

export type PaymentErrorInput = {
  errorCodes: Array<Scalars['String']['input']>;
};

export type PersonalVoucherStatus = {
  __typename?: 'PersonalVoucherStatus';
  campaignName?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  generatedUniqueCodes?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Type of physical examination */
export enum PhysicalExaminationEnum {
  Basic = 'Basic',
  Extended = 'Extended',
  NotSpecified = 'NotSpecified'
}

export type ProductCalculationPricesDto = {
  __typename?: 'ProductCalculationPricesDto';
  creditCard: Scalars['Float']['output'];
  creditCardWithInstallments: Scalars['Float']['output'];
  generalTransfer: Scalars['Float']['output'];
  generalTransferWithInstallments: Scalars['Float']['output'];
};

export type ProductTypeGraphQl = {
  __typename?: 'ProductTypeGraphQL';
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProductTypeSpecificType = {
  __typename?: 'ProductTypeSpecificType';
  additionalInsuranceInfo?: Maybe<SoHealthAdditionalInfoType>;
  insuredPerson?: Maybe<SoHealthInsuredPersonType>;
};

export type Query = {
  __typename?: 'Query';
  checkoutHealthOffer?: Maybe<CheckoutHealthOfferDto>;
  checkoutHealthOfferData?: Maybe<HealthOfferData>;
  checkoutHealthOfferGeneralTransferDetails?: Maybe<GeneralTransferInfo>;
  checkoutHealthOfferPaymentOptions?: Maybe<OfferPaymentOptions>;
  checkoutHealthOffers?: Maybe<Array<CheckoutHealthOfferDto>>;
  getAdmin?: Maybe<AdminDto>;
  getCalculations: Array<CalculationResponseDto>;
  getGeneralTransferPaymentDetails?: Maybe<GeneralTransferInfo>;
  getOffer?: Maybe<GetOfferDto>;
  getOfferForAgent?: Maybe<GetOfferDto>;
  getOfferForPrint?: Maybe<GetOfferDto>;
  getOfferPaymentOptions?: Maybe<OfferPaymentOptions>;
  getOffersBySoId?: Maybe<Array<GetOfferDto>>;
  getSo?: Maybe<GetSoDto>;
  getTermsAndConditions?: Maybe<OfferTermsAndConditionsGetDto>;
  getTermsAndConditionsById?: Maybe<TermsAndConditionsDto>;
  getTermsAndConditionsFromFiles?: Maybe<OfferTermsAndConditionsGetDto>;
  getTermsOffer?: Maybe<GetOfferDto>;
  getWSPayPaymentData?: Maybe<WspayPaymentData>;
  hasActiveAdditionalHealthPolicy?: Maybe<Scalars['Boolean']['output']>;
  healthQuestionnaireQuestions: Array<QuestionDto>;
  overflowVoucherStatus?: Maybe<OverflowVoucherStatus>;
  personalVoucherStatus?: Maybe<PersonalVoucherStatus>;
  soPartner?: Maybe<SoPartnerDto>;
};


export type QueryCheckoutHealthOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckoutHealthOfferDataArgs = {
  id: Scalars['String']['input'];
};


export type QueryCheckoutHealthOfferGeneralTransferDetailsArgs = {
  installments: Scalars['Int']['input'];
  offerId: Scalars['String']['input'];
};


export type QueryCheckoutHealthOfferPaymentOptionsArgs = {
  offerId: Scalars['String']['input'];
};


export type QueryCheckoutHealthOffersArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetAdminArgs = {
  referenceId: Scalars['String']['input'];
};


export type QueryGetCalculationsArgs = {
  input: CalculationRequestInput;
  soId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGeneralTransferPaymentDetailsArgs = {
  id: Scalars['String']['input'];
  input: GeneralTransferDetailsInput;
};


export type QueryGetOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOfferForAgentArgs = {
  adminId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QueryGetOfferForPrintArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOfferPaymentOptionsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetOffersBySoIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSoArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTermsAndConditionsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTermsAndConditionsByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTermsAndConditionsFromFilesArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetTermsOfferArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetWsPayPaymentDataArgs = {
  id: Scalars['String']['input'];
  input: GetWspayPaymentDataInput;
};


export type QueryHasActiveAdditionalHealthPolicyArgs = {
  id: Scalars['String']['input'];
};


export type QueryHealthQuestionnaireQuestionsArgs = {
  brandCode: Scalars['String']['input'];
  dontExclude?: InputMaybe<Scalars['Boolean']['input']>;
  productCode: Scalars['String']['input'];
};


export type QueryPersonalVoucherStatusArgs = {
  soId: Scalars['String']['input'];
};


export type QuerySoPartnerArgs = {
  soId: Scalars['String']['input'];
};

export type QuestionDto = {
  __typename?: 'QuestionDto';
  code: Scalars['String']['output'];
  columns?: Maybe<Array<QuestionnaireQuestionColumnDto>>;
  description?: Maybe<Scalars['String']['output']>;
  extraInfo?: Maybe<Scalars['String']['output']>;
  followUp?: Maybe<QuestionnaireFollowUpDto>;
  options?: Maybe<Array<QuestionnaireQuestionOptionDto>>;
  questions?: Maybe<Array<QuestionDto>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  rows?: Maybe<Array<QuestionnaireQuestionRowDto>>;
  selectionMode?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireFollowUpConditionDto = {
  __typename?: 'QuestionnaireFollowUpConditionDto';
  countWhere?: Maybe<QuestionnaireFollowUpCountWhereDto>;
  operator?: Maybe<Scalars['String']['output']>;
  parentQuestionCode: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  when: Scalars['String']['output'];
};

export type QuestionnaireFollowUpCountWhereDto = {
  __typename?: 'QuestionnaireFollowUpCountWhereDto';
  answer?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionnaireFollowUpDto = {
  __typename?: 'QuestionnaireFollowUpDto';
  code: Scalars['String']['output'];
  fields?: Maybe<Array<QuestionnaireFollowUpFieldDto>>;
  requireWhen?: Maybe<QuestionnaireFollowUpConditionDto>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  visibility?: Maybe<QuestionnaireFollowUpConditionDto>;
};

export type QuestionnaireFollowUpFieldDto = {
  __typename?: 'QuestionnaireFollowUpFieldDto';
  code: Scalars['String']['output'];
  inputType: Scalars['String']['output'];
  label: Scalars['String']['output'];
  options?: Maybe<Array<QuestionnaireFollowUpFieldOptionDto>>;
  required?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionnaireFollowUpFieldOptionDto = {
  __typename?: 'QuestionnaireFollowUpFieldOptionDto';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionnaireQuestionColumnDto = {
  __typename?: 'QuestionnaireQuestionColumnDto';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionnaireQuestionOptionDto = {
  __typename?: 'QuestionnaireQuestionOptionDto';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type QuestionnaireQuestionRowDto = {
  __typename?: 'QuestionnaireQuestionRowDto';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type SaveHealthQuestionnaireAnswersInput = {
  answers: Array<HealthQuestionnaireAnswerItemInput>;
  brandCode: Scalars['String']['input'];
};

export type SoHealthAdditionalInfoInput = {
  diagnostic: Scalars['Boolean']['input'];
  laboratoryExaminations?: InputMaybe<SpecialistExaminationsEnum>;
  mrCt: Scalars['Boolean']['input'];
  perMonthPayment: Scalars['String']['input'];
  physicalExamination?: InputMaybe<PhysicalExaminationEnum>;
  physicalTherapy: Scalars['Boolean']['input'];
  reasonOfPurchase: Scalars['String']['input'];
  smallOperatingCycles: Scalars['Boolean']['input'];
  specialistExaminations: Scalars['Boolean']['input'];
};

export type SoHealthAdditionalInfoType = {
  __typename?: 'SoHealthAdditionalInfoType';
  diagnostic: Scalars['Boolean']['output'];
  laboratoryExaminations?: Maybe<SpecialistExaminationsEnum>;
  mrCt: Scalars['Boolean']['output'];
  perMonthPayment: Scalars['String']['output'];
  physicalExamination?: Maybe<PhysicalExaminationEnum>;
  physicalTherapy: Scalars['Boolean']['output'];
  reasonOfPurchase: Scalars['String']['output'];
  smallOperatingCycles: Scalars['Boolean']['output'];
  specialistExaminations: Scalars['Boolean']['output'];
};

export type SoHealthInsuredPersonType = {
  __typename?: 'SoHealthInsuredPersonType';
  accessAge?: Maybe<Scalars['Float']['output']>;
  asEntity?: Maybe<Scalars['String']['output']>;
  birthDate?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  cityKompareId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  importantNote?: Maybe<Scalars['String']['output']>;
  isRegularDelivery?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  newPolicyStartDate?: Maybe<Scalars['String']['output']>;
  oib?: Maybe<Scalars['String']['output']>;
  oldPolicyNumber?: Maybe<Scalars['String']['output']>;
  partnerContactEmail?: Maybe<Scalars['String']['output']>;
  personType?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetAndHouseNumber?: Maybe<Scalars['String']['output']>;
  streetKompareId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['Float']['output']>;
};

export type SoPartnerDto = {
  __typename?: 'SoPartnerDto';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Type of specialist/laboratory examinations */
export enum SpecialistExaminationsEnum {
  Basic = 'Basic',
  Extended = 'Extended'
}

export type StringEditableValue = {
  __typename?: 'StringEditableValue';
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SubmitHealthQuestionnaireResponseDto = {
  __typename?: 'SubmitHealthQuestionnaireResponseDto';
  messages: Array<Scalars['String']['output']>;
  needsConfirmation: Scalars['Boolean']['output'];
  rejected: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  offerChanged?: Maybe<GetOfferDto>;
  offersChanged: Scalars['String']['output'];
};


export type SubscriptionOfferChangedArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionOffersChangedArgs = {
  soId: Scalars['String']['input'];
};

export type TermsAndConditionsDto = {
  __typename?: 'TermsAndConditionsDto';
  contentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type TermsInput = {
  allianzGDPRAcceptedAt: Scalars['Boolean']['input'];
};

export type WebCalculationCoverage = {
  __typename?: 'WebCalculationCoverage';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editOnWeb?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type WebCalculationPrice = {
  __typename?: 'WebCalculationPrice';
  totalOneTimePayment: Scalars['Float']['output'];
  totalWithInstallments?: Maybe<Scalars['Float']['output']>;
};

/** WSPay callback / redirect payload fields */
export type WsPayResponseInput = {
  wsPayAmount?: InputMaybe<Scalars['String']['input']>;
  wsPayApprovalCode?: InputMaybe<Scalars['String']['input']>;
  wsPayConfirmationSignature?: InputMaybe<Scalars['String']['input']>;
  wsPayCreditCardNumber?: InputMaybe<Scalars['String']['input']>;
  wsPayCustomerFirstName?: InputMaybe<Scalars['String']['input']>;
  wsPayCustomerLastName?: InputMaybe<Scalars['String']['input']>;
  wsPayDateTime?: InputMaybe<Scalars['String']['input']>;
  wsPayOrderId?: InputMaybe<Scalars['String']['input']>;
  wsPayPartner?: InputMaybe<Scalars['String']['input']>;
  wsPayPaymentPlan?: InputMaybe<Scalars['String']['input']>;
  wsPayPaymentType?: InputMaybe<Scalars['String']['input']>;
  wsPaySTAN?: InputMaybe<Scalars['String']['input']>;
  wsPayShoppingCartId?: InputMaybe<Scalars['String']['input']>;
  wsPaySuccess?: InputMaybe<Scalars['String']['input']>;
};

/** WSPay payment form / redirect parameters */
export type WspayPaymentData = {
  __typename?: 'WspayPaymentData';
  CancelURL: Scalars['String']['output'];
  CustomerAddress?: Maybe<Scalars['String']['output']>;
  CustomerCity?: Maybe<Scalars['String']['output']>;
  CustomerCountry?: Maybe<Scalars['String']['output']>;
  CustomerEmail?: Maybe<Scalars['String']['output']>;
  CustomerFirstName?: Maybe<Scalars['String']['output']>;
  CustomerLastName?: Maybe<Scalars['String']['output']>;
  CustomerPhone?: Maybe<Scalars['String']['output']>;
  CustomerZIP?: Maybe<Scalars['String']['output']>;
  Iframe?: Maybe<Scalars['String']['output']>;
  IframeResponseTarget?: Maybe<Scalars['String']['output']>;
  PaymentMethod?: Maybe<Scalars['String']['output']>;
  PaymentPlan?: Maybe<Scalars['String']['output']>;
  ReturnErrorURL: Scalars['String']['output'];
  ReturnURL: Scalars['String']['output'];
  ShopID: Scalars['String']['output'];
  ShoppingCartID: Scalars['String']['output'];
  Signature: Scalars['String']['output'];
  TotalAmount: Scalars['String']['output'];
  Version: Scalars['String']['output'];
};

export type AcceptTermsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: TermsInput;
}>;


export type AcceptTermsMutation = { __typename?: 'Mutation', acceptTerms?: string | null };

export type CallMeSupplementaryMutationVariables = Exact<{
  input: CallMeInput;
}>;


export type CallMeSupplementaryMutation = { __typename?: 'Mutation', callMe: string };

export type CheckAndApplyVoucherCodeMutationVariables = Exact<{
  voucherCode: Scalars['String']['input'];
  offerId: Scalars['String']['input'];
}>;


export type CheckAndApplyVoucherCodeMutation = { __typename?: 'Mutation', checkAndApplyVoucherCode?: { __typename?: 'CheckoutHealthOfferDto', _id: string, soId?: string | null, status: string, brandId?: string | null, annotations?: Array<string> | null, supplementary?: { __typename?: 'HealthOfferBranchDto', label?: string | null, brandName?: string | null, brandCode?: string | null, numberOfInstallments?: number | null, code?: string | null, logoUrl?: string | null, priceChangeModifier?: { __typename?: 'HealthOfferPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'HealthOfferVoucherPriceModifierDto', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'HealthOfferVoucherPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, visual?: { __typename?: 'HealthOfferVisualDto', highlight?: boolean | null, tooltip?: string | null, description?: string | null } | null, fixedCoverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, coverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, discounts?: Array<{ __typename?: 'HealthOfferDiscountDto', value?: string | null, tooltip?: string | null }> | null, paymentSlipInfo?: { __typename?: 'HealthOfferPaymentSlipInfoDto', amount?: number | null, numOfInstallments?: number | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null, includedInPrice?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null, additionalCoverages?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null } | null, additional?: { __typename?: 'HealthOfferBranchDto', label?: string | null, brandName?: string | null, brandCode?: string | null, numberOfInstallments?: number | null, code?: string | null, logoUrl?: string | null, priceChangeModifier?: { __typename?: 'HealthOfferPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'HealthOfferVoucherPriceModifierDto', amount?: number | null } | null, visual?: { __typename?: 'HealthOfferVisualDto', highlight?: boolean | null, tooltip?: string | null, description?: string | null } | null, coverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, fixedCoverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, discounts?: Array<{ __typename?: 'HealthOfferDiscountDto', value?: string | null, tooltip?: string | null }> | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null, includedInPrice?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null, additionalCoverages?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null };

export type SetWsPayResponseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: WsPayResponseInput;
}>;


export type SetWsPayResponseMutation = { __typename?: 'Mutation', setWsPayResponse?: string | null };

export type CreateSoSupplementaryMutationVariables = Exact<{
  input: CreateSoInput;
}>;


export type CreateSoSupplementaryMutation = { __typename?: 'Mutation', createSo: string };

export type CreateCheckoutHealthOfferMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: CreateOfferInput;
}>;


export type CreateCheckoutHealthOfferMutation = { __typename?: 'Mutation', createHealthOffer?: string | null };

export type RemoveVoucherCodeMutationVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;


export type RemoveVoucherCodeMutation = { __typename?: 'Mutation', removeVoucherCode?: { __typename?: 'CheckoutHealthOfferDto', _id: string, soId?: string | null, status: string, brandId?: string | null, annotations?: Array<string> | null, supplementary?: { __typename?: 'HealthOfferBranchDto', label?: string | null, brandName?: string | null, brandCode?: string | null, numberOfInstallments?: number | null, code?: string | null, logoUrl?: string | null, priceChangeModifier?: { __typename?: 'HealthOfferPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'HealthOfferVoucherPriceModifierDto', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'HealthOfferVoucherPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, visual?: { __typename?: 'HealthOfferVisualDto', highlight?: boolean | null, tooltip?: string | null, description?: string | null } | null, fixedCoverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, coverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, discounts?: Array<{ __typename?: 'HealthOfferDiscountDto', value?: string | null, tooltip?: string | null }> | null, paymentSlipInfo?: { __typename?: 'HealthOfferPaymentSlipInfoDto', amount?: number | null, numOfInstallments?: number | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null, includedInPrice?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null, additionalCoverages?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null } | null, additional?: { __typename?: 'HealthOfferBranchDto', label?: string | null, brandName?: string | null, brandCode?: string | null, numberOfInstallments?: number | null, code?: string | null, logoUrl?: string | null, priceChangeModifier?: { __typename?: 'HealthOfferPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'HealthOfferVoucherPriceModifierDto', amount?: number | null } | null, visual?: { __typename?: 'HealthOfferVisualDto', highlight?: boolean | null, tooltip?: string | null, description?: string | null } | null, coverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, fixedCoverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, discounts?: Array<{ __typename?: 'HealthOfferDiscountDto', value?: string | null, tooltip?: string | null }> | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null, includedInPrice?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null, additionalCoverages?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null };

export type SaveConsentMutationVariables = Exact<{
  params: ConsentInput;
}>;


export type SaveConsentMutation = { __typename?: 'Mutation', saveConsent: boolean };

export type SavePolicyCancellationMutationVariables = Exact<{
  soId: Scalars['String']['input'];
  cancellationDate?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
}>;


export type SavePolicyCancellationMutation = { __typename?: 'Mutation', savePolicyCancellation: boolean };

export type SendGeneralTransferDetailsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: GeneralTransferDetailsInput;
}>;


export type SendGeneralTransferDetailsMutation = { __typename?: 'Mutation', sendGeneralTransferDetails?: string | null };

export type SendOffersToEmailMutationVariables = Exact<{
  soId: Scalars['String']['input'];
}>;


export type SendOffersToEmailMutation = { __typename?: 'Mutation', sendOffersToEmail: boolean };

export type SendPolicyCancelationEmailMutationVariables = Exact<{
  soId: Scalars['String']['input'];
}>;


export type SendPolicyCancelationEmailMutation = { __typename?: 'Mutation', sendPolicyCancelationEmail: boolean };

export type SetInsuranceNumberMutationVariables = Exact<{
  soId: Scalars['String']['input'];
  insuranceNumber: Scalars['String']['input'];
}>;


export type SetInsuranceNumberMutation = { __typename?: 'Mutation', setInsuranceNumber: boolean };

export type PaymentAttemptMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PaymentAttemptMutation = { __typename?: 'Mutation', paymentAttempt?: string | null };

export type CheckoutPaymentErrorsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: PaymentErrorInput;
}>;


export type CheckoutPaymentErrorsMutation = { __typename?: 'Mutation', checkoutPaymentErrors?: string | null };

export type UpdateCheckoutHealthOfferDataMutationVariables = Exact<{
  params: CheckoutHealthOfferDataInput;
}>;


export type UpdateCheckoutHealthOfferDataMutation = { __typename?: 'Mutation', updateCheckoutHealthOfferData: boolean };

export type GetAdminQueryVariables = Exact<{
  referenceId: Scalars['String']['input'];
}>;


export type GetAdminQuery = { __typename?: 'Query', getAdmin?: { __typename?: 'AdminDto', id: string, avatar?: string | null, name: string, email: string, phone?: string | null, phoneExt?: number | null, signature?: string | null, emailName?: string | null } | null };

export type CheckoutHealthOfferQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
  soId: Scalars['String']['input'];
}>;


export type CheckoutHealthOfferQuery = { __typename?: 'Query', checkoutHealthOffer?: { __typename?: 'CheckoutHealthOfferDto', _id: string, soId?: string | null, status: string, brandId?: string | null, paidAt?: string | null, isPublished?: boolean | null, termsAcceptedAt?: string | null, iddTermsAcceptedAt?: string | null, allianzGDPRAcceptedAt?: string | null, acceptedEmailDocumentationDeliveryAt?: string | null, annotations?: Array<string> | null, supplementary?: { __typename?: 'HealthOfferBranchDto', label?: string | null, actionLabel?: string | null, brandName?: string | null, brandCode?: string | null, code?: string | null, numberOfInstallments?: number | null, baseProductPrice?: number | null, logoUrl?: string | null, priceChangeModifier?: { __typename?: 'HealthOfferPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'HealthOfferVoucherPriceModifierDto', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'HealthOfferVoucherPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, visual?: { __typename?: 'HealthOfferVisualDto', highlight?: boolean | null, tooltip?: string | null, description?: string | null } | null, fixedCoverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, coverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, discounts?: Array<{ __typename?: 'HealthOfferDiscountDto', value?: string | null, tooltip?: string | null }> | null, paymentSlipInfo?: { __typename?: 'HealthOfferPaymentSlipInfoDto', amount?: number | null, numOfInstallments?: number | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null, includedInPrice?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null, additionalCoverages?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null } | null, additional?: { __typename?: 'HealthOfferBranchDto', label?: string | null, actionLabel?: string | null, brandName?: string | null, brandCode?: string | null, code?: string | null, numberOfInstallments?: number | null, baseProductPrice?: number | null, logoUrl?: string | null, priceChangeModifier?: { __typename?: 'HealthOfferPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'HealthOfferVoucherPriceModifierDto', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'HealthOfferVoucherPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, visual?: { __typename?: 'HealthOfferVisualDto', highlight?: boolean | null, tooltip?: string | null, description?: string | null } | null, fixedCoverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, coverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, discounts?: Array<{ __typename?: 'HealthOfferDiscountDto', value?: string | null, tooltip?: string | null }> | null, paymentSlipInfo?: { __typename?: 'HealthOfferPaymentSlipInfoDto', amount?: number | null, numOfInstallments?: number | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, checkoutHealthOfferData?: { __typename?: 'HealthOfferData', karenca?: boolean | null, hasPolicy?: boolean | null, newPolicyStartDate?: string | null, newPolicyStartDateNote?: string | null, productCode?: string | null, insuredPerson?: { __typename?: 'HealthOfferDataInsuredPerson', firstName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, lastName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, birthDate?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, gender?: { __typename?: 'GenderEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetAndHouseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, street?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, houseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, city?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, cityKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, zipCode?: { __typename?: 'IntEditableValue', value?: number | null, isEditable?: boolean | null } | null, oib?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, insuranceNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, personalIdNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, personalIdIssuer?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, partnerContactEmail?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null } | null, contractor?: { __typename?: 'HealthOfferDataContractor', personType?: string | null, isSamePerson?: boolean | null, person?: { __typename?: 'HealthOfferDataContractorPerson', firstName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, lastName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, birthDate?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, gender?: { __typename?: 'GenderEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetAndHouseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, street?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, houseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, city?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, cityKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, zipCode?: { __typename?: 'IntEditableValue', value?: number | null, isEditable?: boolean | null } | null, oib?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, partnerContactEmail?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null } | null, company?: { __typename?: 'HealthOfferDataContractorCompany', companyName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, oib?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetAndHouseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, street?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, houseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, city?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, cityKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, zipCode?: { __typename?: 'IntEditableValue', value?: number | null, isEditable?: boolean | null } | null, partnerContactEmail?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null } | null } | null, delivery?: { __typename?: 'HealthOfferDataDelivery', asEntity?: { __typename?: 'DeliveryEntityEditableValue', value?: string | null, isEditable?: boolean | null } | null, name?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetAndHouseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, street?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, houseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, city?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, cityKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, zipCode?: { __typename?: 'IntEditableValue', value?: number | null, isEditable?: boolean | null } | null } | null } | null, getTermsAndConditionsFromFiles?: { __typename?: 'OfferTermsAndConditionsGetDto', brandName: string, brandCode: string, logoUrl: string, documents: Array<{ __typename?: 'OfferTermsAndConditionsDocumentDto', fileId: string, fileName: string }> } | null, overflowVoucherStatus?: { __typename?: 'OverflowVoucherStatus', active: boolean, voucherCode: string, voucherValue: number, voucherDescription: string } | null, personalVoucherStatus?: { __typename?: 'PersonalVoucherStatus', value?: number | null, code?: string | null, type?: string | null, description?: string | null, campaignName?: string | null, name?: string | null, generatedUniqueCodes?: Array<string> | null, startDate?: string | null, endDate?: string | null, status?: string | null } | null };

export type CheckoutHealthOfferDataQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;


export type CheckoutHealthOfferDataQuery = { __typename?: 'Query', checkoutHealthOfferData?: { __typename?: 'HealthOfferData', karenca?: boolean | null, hasPolicy?: boolean | null, newPolicyStartDate?: string | null, newPolicyStartDateNote?: string | null, productCode?: string | null, collectContractorPhone?: boolean | null, insuredPerson?: { __typename?: 'HealthOfferDataInsuredPerson', firstName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, lastName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, birthDate?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, gender?: { __typename?: 'GenderEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetAndHouseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, street?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, houseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, city?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, cityKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, zipCode?: { __typename?: 'IntEditableValue', value?: number | null, isEditable?: boolean | null } | null, oib?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, personalIdNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, personalIdIssuer?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, partnerContactEmail?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null } | null, contractor?: { __typename?: 'HealthOfferDataContractor', personType?: string | null, isSamePerson?: boolean | null, person?: { __typename?: 'HealthOfferDataContractorPerson', firstName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, lastName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, birthDate?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, gender?: { __typename?: 'GenderEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetAndHouseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, street?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, houseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, city?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, cityKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, zipCode?: { __typename?: 'IntEditableValue', value?: number | null, isEditable?: boolean | null } | null, oib?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, partnerContactEmail?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, phoneNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null } | null, company?: { __typename?: 'HealthOfferDataContractorCompany', streetAndHouseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, street?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, houseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, oib?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, city?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, cityKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, companyName?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, zipCode?: { __typename?: 'IntEditableValue', value?: number | null, isEditable?: boolean | null } | null, partnerContactEmail?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, phoneNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null } | null } | null, delivery?: { __typename?: 'HealthOfferDataDelivery', asEntity?: { __typename?: 'DeliveryEntityEditableValue', value?: string | null, isEditable?: boolean | null } | null, name?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetAndHouseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, street?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, streetKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, houseNumber?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, city?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, cityKompareId?: { __typename?: 'StringEditableValue', value?: string | null, isEditable?: boolean | null } | null, zipCode?: { __typename?: 'IntEditableValue', value?: number | null, isEditable?: boolean | null } | null } | null } | null };

export type GetGeneralTransferPaymentDetailsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: GeneralTransferDetailsInput;
}>;


export type GetGeneralTransferPaymentDetailsQuery = { __typename?: 'Query', getGeneralTransferPaymentDetails?: { __typename?: 'GeneralTransferInfo', price: number, customerFirstName: string, customerLastName: string, customerAddress: string, customerCity: string, customerZipCode: string, customerCountry: string, customerPhone?: string | null, customerEmail?: string | null, customerOib: string, recipientName: string, recipientAddress: string, recipientCity: string, recipientZipCode: string, recipientAccountNumber: string, referenceNumber: string, referenceNumberType: string, referencePrefix: string, referenceSuffix: string, model: string, description: string, numberOfInstallments?: number | null } | null };

export type CheckoutHealthOfferPaymentOptionsQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
  soId: Scalars['String']['input'];
}>;


export type CheckoutHealthOfferPaymentOptionsQuery = { __typename?: 'Query', checkoutHealthOfferPaymentOptions?: { __typename?: 'OfferPaymentOptions', offer?: { __typename?: 'CheckoutHealthOfferDto', status: string, brandId?: string | null, supplementary?: { __typename?: 'HealthOfferBranchDto', label?: string | null, brandName?: string | null, brandCode?: string | null, code?: string | null, actionLabel?: string | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, additional?: { __typename?: 'HealthOfferBranchDto', label?: string | null, brandName?: string | null, brandCode?: string | null, code?: string | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null } | null, paymentOptions: Array<{ __typename?: 'HealthOfferPaymentOption', paymentOption: string, paymentTypes: Array<{ __typename?: 'HealthOfferPaymentType', paymentType: string, paymentTypeLabel: string, installments: Array<{ __typename?: 'HealthOfferPaymentInstallment', installment: number, amount: number, paymentTypeDiscount: number }> }>, paymentSlipInfo?: { __typename?: 'HealthOfferPaymentSlipInfo', amount?: number | null, numOfInstallments?: number | null } | null }> } | null, checkoutHealthOfferGeneralTransferDetailsOneTime?: { __typename?: 'GeneralTransferInfo', price: number, customerFirstName: string, customerLastName: string, customerAddress: string, customerCity: string, customerZipCode: string, customerCountry: string, customerPhone?: string | null, customerEmail?: string | null, customerOib: string, recipientAccountNumber: string, recipientAddress: string, recipientCity: string, recipientZipCode: string, recipientName: string, referenceNumber: string, referenceNumberType: string, referencePrefix: string, referenceSuffix: string, model: string, description: string, numberOfInstallments?: number | null } | null, checkoutHealthOfferGeneralTransferDetailsInstallments?: { __typename?: 'GeneralTransferInfo', price: number, customerFirstName: string, customerLastName: string, customerAddress: string, customerCity: string, customerZipCode: string, customerCountry: string, customerPhone?: string | null, customerEmail?: string | null, customerOib: string, recipientAccountNumber: string, recipientAddress: string, recipientCity: string, recipientZipCode: string, recipientName: string, referenceNumber: string, referenceNumberType: string, referencePrefix: string, referenceSuffix: string, model: string, description: string, numberOfInstallments?: number | null } | null, checkoutHealthOffer?: { __typename?: 'CheckoutHealthOfferDto', _id: string, soId?: string | null, status: string, brandId?: string | null, annotations?: Array<string> | null, supplementary?: { __typename?: 'HealthOfferBranchDto', label?: string | null, actionLabel?: string | null, brandName?: string | null, brandCode?: string | null, numberOfInstallments?: number | null, code?: string | null, logoUrl?: string | null, priceChangeModifier?: { __typename?: 'HealthOfferPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'HealthOfferVoucherPriceModifierDto', amount?: number | null } | null, voucherPriceChangeModifier?: { __typename?: 'HealthOfferVoucherPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null, code?: string | null } | null, visual?: { __typename?: 'HealthOfferVisualDto', highlight?: boolean | null, tooltip?: string | null, description?: string | null } | null, fixedCoverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, coverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, discounts?: Array<{ __typename?: 'HealthOfferDiscountDto', value?: string | null, tooltip?: string | null }> | null, paymentSlipInfo?: { __typename?: 'HealthOfferPaymentSlipInfoDto', amount?: number | null, numOfInstallments?: number | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, additional?: { __typename?: 'HealthOfferBranchDto', label?: string | null, brandName?: string | null, brandCode?: string | null, numberOfInstallments?: number | null, code?: string | null, logoUrl?: string | null, priceChangeModifier?: { __typename?: 'HealthOfferPriceChangeModifierDto', amount?: number | null, type?: string | null, description?: string | null } | null, voucherPriceModifier?: { __typename?: 'HealthOfferVoucherPriceModifierDto', amount?: number | null } | null, visual?: { __typename?: 'HealthOfferVisualDto', highlight?: boolean | null, tooltip?: string | null, description?: string | null } | null, coverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, fixedCoverages?: Array<{ __typename?: 'HealthOfferCoverageDto', label?: string | null, tooltip?: string | null, value?: string | null, price?: number | null, gratis?: { __typename?: 'HealthOfferGratisDto', value?: boolean | null, type?: string | null } | null, options?: Array<{ __typename?: 'HealthOfferCoverageOptionDto', key: string, value?: string | null }> | null }> | null, discounts?: Array<{ __typename?: 'HealthOfferDiscountDto', value?: string | null, tooltip?: string | null }> | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null } | null, overflowVoucherStatus?: { __typename?: 'OverflowVoucherStatus', active: boolean, voucherCode: string, voucherValue: number, voucherDescription: string } | null, personalVoucherStatus?: { __typename?: 'PersonalVoucherStatus', value?: number | null, code?: string | null, type?: string | null, description?: string | null, campaignName?: string | null, name?: string | null, generatedUniqueCodes?: Array<string> | null, startDate?: string | null, endDate?: string | null, status?: string | null } | null };

export type GetWsPayPaymentDataQueryVariables = Exact<{
  id: Scalars['String']['input'];
  input: GetWspayPaymentDataInput;
}>;


export type GetWsPayPaymentDataQuery = { __typename?: 'Query', getWSPayPaymentData?: { __typename?: 'WspayPaymentData', ShopID: string, ShoppingCartID: string, TotalAmount: string, Signature: string, ReturnURL: string, CancelURL: string, ReturnErrorURL: string, PaymentPlan?: string | null, CustomerFirstName?: string | null, CustomerLastName?: string | null, CustomerAddress?: string | null, CustomerCity?: string | null, CustomerZIP?: string | null, CustomerCountry?: string | null, CustomerPhone?: string | null, CustomerEmail?: string | null, PaymentMethod?: string | null, Iframe?: string | null, IframeResponseTarget?: string | null, Version: string } | null };

export type CheckoutHealthOffersQueryVariables = Exact<{
  soId: Scalars['String']['input'];
}>;


export type CheckoutHealthOffersQuery = { __typename?: 'Query', checkoutHealthOffers?: Array<{ __typename?: 'CheckoutHealthOfferDto', _id: string, soId?: string | null, brandId?: string | null, status: string, paidAt?: string | null, isPublished?: boolean | null, annotations?: Array<string> | null, termsAcceptedAt?: string | null, iddTermsAcceptedAt?: string | null, allianzGDPRAcceptedAt?: string | null, acceptedEmailDocumentationDeliveryAt?: string | null, supplementary?: { __typename?: 'HealthOfferBranchDto', label?: string | null, code?: string | null, brandName?: string | null, brandCode?: string | null, logoUrl?: string | null, numberOfInstallments?: number | null, baseProductPrice?: number | null, actionLabel?: string | null, includedInPrice?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null, additionalCoverages?: Array<{ __typename?: 'HealthOfferIncludedItemDto', label?: string | null, description?: string | null }> | null } | null, additional?: { __typename?: 'HealthOfferBranchDto', label?: string | null, code?: string | null, brandName?: string | null, brandCode?: string | null, logoUrl?: string | null, numberOfInstallments?: number | null, baseProductPrice?: number | null } | null, total?: { __typename?: 'HealthOfferTotalDto', generalTransfer?: number | null, generalTransferWithInstallments?: number | null, creditCard?: number | null, creditCardWithInstallments?: number | null } | null }> | null };

export type CrossSellAdditionalInfoQueryVariables = Exact<{
  offerId: Scalars['String']['input'];
}>;


export type CrossSellAdditionalInfoQuery = { __typename?: 'Query', hasActiveAdditionalHealthPolicy?: boolean | null, overflowVoucherStatus?: { __typename?: 'OverflowVoucherStatus', active: boolean, voucherCode: string, voucherValue: number, voucherDescription: string } | null, checkoutHealthOfferData?: { __typename?: 'HealthOfferData', contractor?: { __typename?: 'HealthOfferDataContractor', person?: { __typename?: 'HealthOfferDataContractorPerson', firstName?: { __typename?: 'StringEditableValue', value?: string | null } | null, lastName?: { __typename?: 'StringEditableValue', value?: string | null } | null, birthDate?: { __typename?: 'StringEditableValue', value?: string | null } | null, phoneNumber?: { __typename?: 'StringEditableValue', value?: string | null } | null, partnerContactEmail?: { __typename?: 'StringEditableValue', value?: string | null } | null } | null } | null, insuredPerson?: { __typename?: 'HealthOfferDataInsuredPerson', firstName?: { __typename?: 'StringEditableValue', value?: string | null } | null, lastName?: { __typename?: 'StringEditableValue', value?: string | null } | null, birthDate?: { __typename?: 'StringEditableValue', value?: string | null } | null, partnerContactEmail?: { __typename?: 'StringEditableValue', value?: string | null } | null } | null } | null };

export type SoPartnerQueryVariables = Exact<{
  soId: Scalars['String']['input'];
}>;


export type SoPartnerQuery = { __typename?: 'Query', soPartner?: { __typename?: 'SoPartnerDto', code: string, name: string } | null };

export type GetCalculationsQueryVariables = Exact<{
  input: CalculationRequestInput;
  soId: Scalars['String']['input'];
}>;


export type GetCalculationsQuery = { __typename?: 'Query', getCalculations: Array<{ __typename?: 'CalculationResponseDto', code: string, brandName?: string | null, actionLabel?: string | null, label?: string | null, priceWithoutDiscounts: number, diffPrice?: number | null, logoUrl?: string | null, prices: { __typename?: 'ProductCalculationPricesDto', generalTransfer: number, generalTransferWithInstallments: number, creditCard: number, creditCardWithInstallments: number }, fixedCoverages?: Array<{ __typename?: 'CalculatorFixedCoverageDto', code: string, label: string, description?: string | null, tooltip?: string | null }> | null, coverages?: Array<{ __typename?: 'CalculatorCoverageWithPriceDto', code: string, label?: string | null, description?: string | null, tooltip?: string | null, editOnWeb?: boolean | null, price?: number | null }> | null, visual?: { __typename?: 'CalculatorProductVisualDto', highlight: boolean, discount: Array<string>, tooltip?: string | null, description: string } | null }>, overflowVoucherStatus?: { __typename?: 'OverflowVoucherStatus', active: boolean, voucherCode: string, voucherValue: number, voucherDescription: string } | null, personalVoucherStatus?: { __typename?: 'PersonalVoucherStatus', value?: number | null, code?: string | null, type?: string | null, description?: string | null, campaignName?: string | null, name?: string | null, generatedUniqueCodes?: Array<string> | null, startDate?: string | null, endDate?: string | null, status?: string | null } | null };


export const AcceptTermsDocument = gql`
    mutation AcceptTerms($id: String!, $input: TermsInput!) {
  acceptTerms(id: $id, input: $input)
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const CallMeSupplementaryDocument = gql`
    mutation callMeSupplementary($input: CallMeInput!) {
  callMe(input: $input)
}
    `;
export type CallMeSupplementaryMutationFn = Apollo.MutationFunction<CallMeSupplementaryMutation, CallMeSupplementaryMutationVariables>;

/**
 * __useCallMeSupplementaryMutation__
 *
 * To run a mutation, you first call `useCallMeSupplementaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallMeSupplementaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callMeSupplementaryMutation, { data, loading, error }] = useCallMeSupplementaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallMeSupplementaryMutation(baseOptions?: Apollo.MutationHookOptions<CallMeSupplementaryMutation, CallMeSupplementaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallMeSupplementaryMutation, CallMeSupplementaryMutationVariables>(CallMeSupplementaryDocument, options);
      }
export type CallMeSupplementaryMutationHookResult = ReturnType<typeof useCallMeSupplementaryMutation>;
export type CallMeSupplementaryMutationResult = Apollo.MutationResult<CallMeSupplementaryMutation>;
export type CallMeSupplementaryMutationOptions = Apollo.BaseMutationOptions<CallMeSupplementaryMutation, CallMeSupplementaryMutationVariables>;
export const CheckAndApplyVoucherCodeDocument = gql`
    mutation checkAndApplyVoucherCode($voucherCode: String!, $offerId: String!) {
  checkAndApplyVoucherCode(voucherCode: $voucherCode, offerId: $offerId) {
    _id
    soId
    status
    brandId
    supplementary {
      label
      brandName
      brandCode
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      voucherPriceChangeModifier {
        amount
        type
        description
        code
      }
      numberOfInstallments
      code
      visual {
        highlight
        tooltip
        description
      }
      logoUrl
      fixedCoverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      coverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      discounts {
        value
        tooltip
      }
      paymentSlipInfo {
        amount
        numOfInstallments
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      includedInPrice {
        label
        description
      }
      additionalCoverages {
        label
        description
      }
    }
    additional {
      label
      brandName
      brandCode
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      numberOfInstallments
      code
      visual {
        highlight
        tooltip
        description
      }
      logoUrl
      coverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      fixedCoverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      discounts {
        value
        tooltip
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      includedInPrice {
        label
        description
      }
      additionalCoverages {
        label
        description
      }
    }
    total {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
    annotations
  }
}
    `;
export type CheckAndApplyVoucherCodeMutationFn = Apollo.MutationFunction<CheckAndApplyVoucherCodeMutation, CheckAndApplyVoucherCodeMutationVariables>;

/**
 * __useCheckAndApplyVoucherCodeMutation__
 *
 * To run a mutation, you first call `useCheckAndApplyVoucherCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckAndApplyVoucherCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkAndApplyVoucherCodeMutation, { data, loading, error }] = useCheckAndApplyVoucherCodeMutation({
 *   variables: {
 *      voucherCode: // value for 'voucherCode'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCheckAndApplyVoucherCodeMutation(baseOptions?: Apollo.MutationHookOptions<CheckAndApplyVoucherCodeMutation, CheckAndApplyVoucherCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckAndApplyVoucherCodeMutation, CheckAndApplyVoucherCodeMutationVariables>(CheckAndApplyVoucherCodeDocument, options);
      }
export type CheckAndApplyVoucherCodeMutationHookResult = ReturnType<typeof useCheckAndApplyVoucherCodeMutation>;
export type CheckAndApplyVoucherCodeMutationResult = Apollo.MutationResult<CheckAndApplyVoucherCodeMutation>;
export type CheckAndApplyVoucherCodeMutationOptions = Apollo.BaseMutationOptions<CheckAndApplyVoucherCodeMutation, CheckAndApplyVoucherCodeMutationVariables>;
export const SetWsPayResponseDocument = gql`
    mutation SetWsPayResponse($id: String!, $input: WsPayResponseInput!) {
  setWsPayResponse(id: $id, input: $input)
}
    `;
export type SetWsPayResponseMutationFn = Apollo.MutationFunction<SetWsPayResponseMutation, SetWsPayResponseMutationVariables>;

/**
 * __useSetWsPayResponseMutation__
 *
 * To run a mutation, you first call `useSetWsPayResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWsPayResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWsPayResponseMutation, { data, loading, error }] = useSetWsPayResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWsPayResponseMutation(baseOptions?: Apollo.MutationHookOptions<SetWsPayResponseMutation, SetWsPayResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWsPayResponseMutation, SetWsPayResponseMutationVariables>(SetWsPayResponseDocument, options);
      }
export type SetWsPayResponseMutationHookResult = ReturnType<typeof useSetWsPayResponseMutation>;
export type SetWsPayResponseMutationResult = Apollo.MutationResult<SetWsPayResponseMutation>;
export type SetWsPayResponseMutationOptions = Apollo.BaseMutationOptions<SetWsPayResponseMutation, SetWsPayResponseMutationVariables>;
export const CreateSoSupplementaryDocument = gql`
    mutation createSoSupplementary($input: CreateSoInput!) {
  createSo(input: $input)
}
    `;
export type CreateSoSupplementaryMutationFn = Apollo.MutationFunction<CreateSoSupplementaryMutation, CreateSoSupplementaryMutationVariables>;

/**
 * __useCreateSoSupplementaryMutation__
 *
 * To run a mutation, you first call `useCreateSoSupplementaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoSupplementaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoSupplementaryMutation, { data, loading, error }] = useCreateSoSupplementaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSoSupplementaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoSupplementaryMutation, CreateSoSupplementaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoSupplementaryMutation, CreateSoSupplementaryMutationVariables>(CreateSoSupplementaryDocument, options);
      }
export type CreateSoSupplementaryMutationHookResult = ReturnType<typeof useCreateSoSupplementaryMutation>;
export type CreateSoSupplementaryMutationResult = Apollo.MutationResult<CreateSoSupplementaryMutation>;
export type CreateSoSupplementaryMutationOptions = Apollo.BaseMutationOptions<CreateSoSupplementaryMutation, CreateSoSupplementaryMutationVariables>;
export const CreateCheckoutHealthOfferDocument = gql`
    mutation createCheckoutHealthOffer($id: String!, $input: CreateOfferInput!) {
  createHealthOffer(id: $id, input: $input)
}
    `;
export type CreateCheckoutHealthOfferMutationFn = Apollo.MutationFunction<CreateCheckoutHealthOfferMutation, CreateCheckoutHealthOfferMutationVariables>;

/**
 * __useCreateCheckoutHealthOfferMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutHealthOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutHealthOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutHealthOfferMutation, { data, loading, error }] = useCreateCheckoutHealthOfferMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutHealthOfferMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutHealthOfferMutation, CreateCheckoutHealthOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutHealthOfferMutation, CreateCheckoutHealthOfferMutationVariables>(CreateCheckoutHealthOfferDocument, options);
      }
export type CreateCheckoutHealthOfferMutationHookResult = ReturnType<typeof useCreateCheckoutHealthOfferMutation>;
export type CreateCheckoutHealthOfferMutationResult = Apollo.MutationResult<CreateCheckoutHealthOfferMutation>;
export type CreateCheckoutHealthOfferMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutHealthOfferMutation, CreateCheckoutHealthOfferMutationVariables>;
export const RemoveVoucherCodeDocument = gql`
    mutation removeVoucherCode($offerId: String!) {
  removeVoucherCode(offerId: $offerId) {
    _id
    soId
    status
    brandId
    supplementary {
      label
      brandName
      brandCode
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      voucherPriceChangeModifier {
        amount
        type
        description
        code
      }
      numberOfInstallments
      code
      visual {
        highlight
        tooltip
        description
      }
      logoUrl
      fixedCoverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      coverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      discounts {
        value
        tooltip
      }
      paymentSlipInfo {
        amount
        numOfInstallments
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      includedInPrice {
        label
        description
      }
      additionalCoverages {
        label
        description
      }
    }
    additional {
      label
      brandName
      brandCode
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      numberOfInstallments
      code
      visual {
        highlight
        tooltip
        description
      }
      logoUrl
      coverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      fixedCoverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      discounts {
        value
        tooltip
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      includedInPrice {
        label
        description
      }
      additionalCoverages {
        label
        description
      }
    }
    total {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
    annotations
  }
}
    `;
export type RemoveVoucherCodeMutationFn = Apollo.MutationFunction<RemoveVoucherCodeMutation, RemoveVoucherCodeMutationVariables>;

/**
 * __useRemoveVoucherCodeMutation__
 *
 * To run a mutation, you first call `useRemoveVoucherCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVoucherCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVoucherCodeMutation, { data, loading, error }] = useRemoveVoucherCodeMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useRemoveVoucherCodeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVoucherCodeMutation, RemoveVoucherCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVoucherCodeMutation, RemoveVoucherCodeMutationVariables>(RemoveVoucherCodeDocument, options);
      }
export type RemoveVoucherCodeMutationHookResult = ReturnType<typeof useRemoveVoucherCodeMutation>;
export type RemoveVoucherCodeMutationResult = Apollo.MutationResult<RemoveVoucherCodeMutation>;
export type RemoveVoucherCodeMutationOptions = Apollo.BaseMutationOptions<RemoveVoucherCodeMutation, RemoveVoucherCodeMutationVariables>;
export const SaveConsentDocument = gql`
    mutation saveConsent($params: ConsentInput!) {
  saveConsent(params: $params)
}
    `;
export type SaveConsentMutationFn = Apollo.MutationFunction<SaveConsentMutation, SaveConsentMutationVariables>;

/**
 * __useSaveConsentMutation__
 *
 * To run a mutation, you first call `useSaveConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConsentMutation, { data, loading, error }] = useSaveConsentMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSaveConsentMutation(baseOptions?: Apollo.MutationHookOptions<SaveConsentMutation, SaveConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConsentMutation, SaveConsentMutationVariables>(SaveConsentDocument, options);
      }
export type SaveConsentMutationHookResult = ReturnType<typeof useSaveConsentMutation>;
export type SaveConsentMutationResult = Apollo.MutationResult<SaveConsentMutation>;
export type SaveConsentMutationOptions = Apollo.BaseMutationOptions<SaveConsentMutation, SaveConsentMutationVariables>;
export const SavePolicyCancellationDocument = gql`
    mutation savePolicyCancellation($soId: String!, $cancellationDate: String, $file: String, $fileName: String, $mimeType: String) {
  savePolicyCancellation(
    id: $soId
    cancellationDate: $cancellationDate
    file: $file
    fileName: $fileName
    mimeType: $mimeType
  )
}
    `;
export type SavePolicyCancellationMutationFn = Apollo.MutationFunction<SavePolicyCancellationMutation, SavePolicyCancellationMutationVariables>;

/**
 * __useSavePolicyCancellationMutation__
 *
 * To run a mutation, you first call `useSavePolicyCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePolicyCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePolicyCancellationMutation, { data, loading, error }] = useSavePolicyCancellationMutation({
 *   variables: {
 *      soId: // value for 'soId'
 *      cancellationDate: // value for 'cancellationDate'
 *      file: // value for 'file'
 *      fileName: // value for 'fileName'
 *      mimeType: // value for 'mimeType'
 *   },
 * });
 */
export function useSavePolicyCancellationMutation(baseOptions?: Apollo.MutationHookOptions<SavePolicyCancellationMutation, SavePolicyCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePolicyCancellationMutation, SavePolicyCancellationMutationVariables>(SavePolicyCancellationDocument, options);
      }
export type SavePolicyCancellationMutationHookResult = ReturnType<typeof useSavePolicyCancellationMutation>;
export type SavePolicyCancellationMutationResult = Apollo.MutationResult<SavePolicyCancellationMutation>;
export type SavePolicyCancellationMutationOptions = Apollo.BaseMutationOptions<SavePolicyCancellationMutation, SavePolicyCancellationMutationVariables>;
export const SendGeneralTransferDetailsDocument = gql`
    mutation sendGeneralTransferDetails($id: String!, $input: GeneralTransferDetailsInput!) {
  sendGeneralTransferDetails(id: $id, input: $input)
}
    `;
export type SendGeneralTransferDetailsMutationFn = Apollo.MutationFunction<SendGeneralTransferDetailsMutation, SendGeneralTransferDetailsMutationVariables>;

/**
 * __useSendGeneralTransferDetailsMutation__
 *
 * To run a mutation, you first call `useSendGeneralTransferDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGeneralTransferDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGeneralTransferDetailsMutation, { data, loading, error }] = useSendGeneralTransferDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendGeneralTransferDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SendGeneralTransferDetailsMutation, SendGeneralTransferDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGeneralTransferDetailsMutation, SendGeneralTransferDetailsMutationVariables>(SendGeneralTransferDetailsDocument, options);
      }
export type SendGeneralTransferDetailsMutationHookResult = ReturnType<typeof useSendGeneralTransferDetailsMutation>;
export type SendGeneralTransferDetailsMutationResult = Apollo.MutationResult<SendGeneralTransferDetailsMutation>;
export type SendGeneralTransferDetailsMutationOptions = Apollo.BaseMutationOptions<SendGeneralTransferDetailsMutation, SendGeneralTransferDetailsMutationVariables>;
export const SendOffersToEmailDocument = gql`
    mutation sendOffersToEmail($soId: String!) {
  sendOffersToEmail(soId: $soId)
}
    `;
export type SendOffersToEmailMutationFn = Apollo.MutationFunction<SendOffersToEmailMutation, SendOffersToEmailMutationVariables>;

/**
 * __useSendOffersToEmailMutation__
 *
 * To run a mutation, you first call `useSendOffersToEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOffersToEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOffersToEmailMutation, { data, loading, error }] = useSendOffersToEmailMutation({
 *   variables: {
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useSendOffersToEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendOffersToEmailMutation, SendOffersToEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOffersToEmailMutation, SendOffersToEmailMutationVariables>(SendOffersToEmailDocument, options);
      }
export type SendOffersToEmailMutationHookResult = ReturnType<typeof useSendOffersToEmailMutation>;
export type SendOffersToEmailMutationResult = Apollo.MutationResult<SendOffersToEmailMutation>;
export type SendOffersToEmailMutationOptions = Apollo.BaseMutationOptions<SendOffersToEmailMutation, SendOffersToEmailMutationVariables>;
export const SendPolicyCancelationEmailDocument = gql`
    mutation sendPolicyCancelationEmail($soId: String!) {
  sendPolicyCancelationEmail(soId: $soId)
}
    `;
export type SendPolicyCancelationEmailMutationFn = Apollo.MutationFunction<SendPolicyCancelationEmailMutation, SendPolicyCancelationEmailMutationVariables>;

/**
 * __useSendPolicyCancelationEmailMutation__
 *
 * To run a mutation, you first call `useSendPolicyCancelationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPolicyCancelationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPolicyCancelationEmailMutation, { data, loading, error }] = useSendPolicyCancelationEmailMutation({
 *   variables: {
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useSendPolicyCancelationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPolicyCancelationEmailMutation, SendPolicyCancelationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPolicyCancelationEmailMutation, SendPolicyCancelationEmailMutationVariables>(SendPolicyCancelationEmailDocument, options);
      }
export type SendPolicyCancelationEmailMutationHookResult = ReturnType<typeof useSendPolicyCancelationEmailMutation>;
export type SendPolicyCancelationEmailMutationResult = Apollo.MutationResult<SendPolicyCancelationEmailMutation>;
export type SendPolicyCancelationEmailMutationOptions = Apollo.BaseMutationOptions<SendPolicyCancelationEmailMutation, SendPolicyCancelationEmailMutationVariables>;
export const SetInsuranceNumberDocument = gql`
    mutation setInsuranceNumber($soId: String!, $insuranceNumber: String!) {
  setInsuranceNumber(id: $soId, insuranceNumber: $insuranceNumber)
}
    `;
export type SetInsuranceNumberMutationFn = Apollo.MutationFunction<SetInsuranceNumberMutation, SetInsuranceNumberMutationVariables>;

/**
 * __useSetInsuranceNumberMutation__
 *
 * To run a mutation, you first call `useSetInsuranceNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInsuranceNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInsuranceNumberMutation, { data, loading, error }] = useSetInsuranceNumberMutation({
 *   variables: {
 *      soId: // value for 'soId'
 *      insuranceNumber: // value for 'insuranceNumber'
 *   },
 * });
 */
export function useSetInsuranceNumberMutation(baseOptions?: Apollo.MutationHookOptions<SetInsuranceNumberMutation, SetInsuranceNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInsuranceNumberMutation, SetInsuranceNumberMutationVariables>(SetInsuranceNumberDocument, options);
      }
export type SetInsuranceNumberMutationHookResult = ReturnType<typeof useSetInsuranceNumberMutation>;
export type SetInsuranceNumberMutationResult = Apollo.MutationResult<SetInsuranceNumberMutation>;
export type SetInsuranceNumberMutationOptions = Apollo.BaseMutationOptions<SetInsuranceNumberMutation, SetInsuranceNumberMutationVariables>;
export const PaymentAttemptDocument = gql`
    mutation paymentAttempt($id: String!) {
  paymentAttempt(id: $id)
}
    `;
export type PaymentAttemptMutationFn = Apollo.MutationFunction<PaymentAttemptMutation, PaymentAttemptMutationVariables>;

/**
 * __usePaymentAttemptMutation__
 *
 * To run a mutation, you first call `usePaymentAttemptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentAttemptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentAttemptMutation, { data, loading, error }] = usePaymentAttemptMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePaymentAttemptMutation(baseOptions?: Apollo.MutationHookOptions<PaymentAttemptMutation, PaymentAttemptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentAttemptMutation, PaymentAttemptMutationVariables>(PaymentAttemptDocument, options);
      }
export type PaymentAttemptMutationHookResult = ReturnType<typeof usePaymentAttemptMutation>;
export type PaymentAttemptMutationResult = Apollo.MutationResult<PaymentAttemptMutation>;
export type PaymentAttemptMutationOptions = Apollo.BaseMutationOptions<PaymentAttemptMutation, PaymentAttemptMutationVariables>;
export const CheckoutPaymentErrorsDocument = gql`
    mutation checkoutPaymentErrors($id: String!, $input: PaymentErrorInput!) {
  checkoutPaymentErrors(id: $id, input: $input)
}
    `;
export type CheckoutPaymentErrorsMutationFn = Apollo.MutationFunction<CheckoutPaymentErrorsMutation, CheckoutPaymentErrorsMutationVariables>;

/**
 * __useCheckoutPaymentErrorsMutation__
 *
 * To run a mutation, you first call `useCheckoutPaymentErrorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutPaymentErrorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutPaymentErrorsMutation, { data, loading, error }] = useCheckoutPaymentErrorsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutPaymentErrorsMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutPaymentErrorsMutation, CheckoutPaymentErrorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutPaymentErrorsMutation, CheckoutPaymentErrorsMutationVariables>(CheckoutPaymentErrorsDocument, options);
      }
export type CheckoutPaymentErrorsMutationHookResult = ReturnType<typeof useCheckoutPaymentErrorsMutation>;
export type CheckoutPaymentErrorsMutationResult = Apollo.MutationResult<CheckoutPaymentErrorsMutation>;
export type CheckoutPaymentErrorsMutationOptions = Apollo.BaseMutationOptions<CheckoutPaymentErrorsMutation, CheckoutPaymentErrorsMutationVariables>;
export const UpdateCheckoutHealthOfferDataDocument = gql`
    mutation updateCheckoutHealthOfferData($params: CheckoutHealthOfferDataInput!) {
  updateCheckoutHealthOfferData(params: $params)
}
    `;
export type UpdateCheckoutHealthOfferDataMutationFn = Apollo.MutationFunction<UpdateCheckoutHealthOfferDataMutation, UpdateCheckoutHealthOfferDataMutationVariables>;

/**
 * __useUpdateCheckoutHealthOfferDataMutation__
 *
 * To run a mutation, you first call `useUpdateCheckoutHealthOfferDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCheckoutHealthOfferDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCheckoutHealthOfferDataMutation, { data, loading, error }] = useUpdateCheckoutHealthOfferDataMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateCheckoutHealthOfferDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCheckoutHealthOfferDataMutation, UpdateCheckoutHealthOfferDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCheckoutHealthOfferDataMutation, UpdateCheckoutHealthOfferDataMutationVariables>(UpdateCheckoutHealthOfferDataDocument, options);
      }
export type UpdateCheckoutHealthOfferDataMutationHookResult = ReturnType<typeof useUpdateCheckoutHealthOfferDataMutation>;
export type UpdateCheckoutHealthOfferDataMutationResult = Apollo.MutationResult<UpdateCheckoutHealthOfferDataMutation>;
export type UpdateCheckoutHealthOfferDataMutationOptions = Apollo.BaseMutationOptions<UpdateCheckoutHealthOfferDataMutation, UpdateCheckoutHealthOfferDataMutationVariables>;
export const GetAdminDocument = gql`
    query getAdmin($referenceId: String!) {
  getAdmin(referenceId: $referenceId) {
    id
    avatar
    name
    email
    phone
    phoneExt
    signature
    emailName
  }
}
    `;

/**
 * __useGetAdminQuery__
 *
 * To run a query within a React component, call `useGetAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useGetAdminQuery(baseOptions: Apollo.QueryHookOptions<GetAdminQuery, GetAdminQueryVariables> & ({ variables: GetAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, options);
      }
export function useGetAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminQuery, GetAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, options);
        }
// @ts-ignore
export function useGetAdminSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminQuery, GetAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminQuery, GetAdminQueryVariables>;
export function useGetAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminQuery, GetAdminQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminQuery | undefined, GetAdminQueryVariables>;
export function useGetAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminQuery, GetAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminQuery, GetAdminQueryVariables>(GetAdminDocument, options);
        }
export type GetAdminQueryHookResult = ReturnType<typeof useGetAdminQuery>;
export type GetAdminLazyQueryHookResult = ReturnType<typeof useGetAdminLazyQuery>;
export type GetAdminSuspenseQueryHookResult = ReturnType<typeof useGetAdminSuspenseQuery>;
export type GetAdminQueryResult = Apollo.QueryResult<GetAdminQuery, GetAdminQueryVariables>;
export const CheckoutHealthOfferDocument = gql`
    query checkoutHealthOffer($offerId: String!, $soId: String!) {
  checkoutHealthOffer(id: $offerId) {
    _id
    soId
    status
    brandId
    paidAt
    isPublished
    termsAcceptedAt
    iddTermsAcceptedAt
    allianzGDPRAcceptedAt
    acceptedEmailDocumentationDeliveryAt
    annotations
    supplementary {
      label
      actionLabel
      brandName
      brandCode
      code
      numberOfInstallments
      baseProductPrice
      logoUrl
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      voucherPriceChangeModifier {
        amount
        type
        description
        code
      }
      visual {
        highlight
        tooltip
        description
      }
      fixedCoverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      coverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      discounts {
        value
        tooltip
      }
      paymentSlipInfo {
        amount
        numOfInstallments
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
      includedInPrice {
        label
        description
      }
      additionalCoverages {
        label
        description
      }
    }
    additional {
      label
      actionLabel
      brandName
      brandCode
      code
      numberOfInstallments
      baseProductPrice
      logoUrl
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      voucherPriceChangeModifier {
        amount
        type
        description
        code
      }
      visual {
        highlight
        tooltip
        description
      }
      fixedCoverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      coverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      discounts {
        value
        tooltip
      }
      paymentSlipInfo {
        amount
        numOfInstallments
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
    }
    total {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
  }
  checkoutHealthOfferData(id: $offerId) {
    karenca
    hasPolicy
    newPolicyStartDate
    newPolicyStartDateNote
    productCode
    insuredPerson {
      firstName {
        value
        isEditable
      }
      lastName {
        value
        isEditable
      }
      birthDate {
        value
        isEditable
      }
      gender {
        value
        isEditable
      }
      streetAndHouseNumber {
        value
        isEditable
      }
      street {
        value
        isEditable
      }
      streetKompareId {
        value
        isEditable
      }
      houseNumber {
        value
        isEditable
      }
      city {
        value
        isEditable
      }
      cityKompareId {
        value
        isEditable
      }
      zipCode {
        value
        isEditable
      }
      oib {
        value
        isEditable
      }
      insuranceNumber {
        value
        isEditable
      }
      personalIdNumber {
        value
        isEditable
      }
      personalIdIssuer {
        value
        isEditable
      }
      partnerContactEmail {
        value
        isEditable
      }
    }
    contractor {
      personType
      isSamePerson
      person {
        firstName {
          value
          isEditable
        }
        lastName {
          value
          isEditable
        }
        birthDate {
          value
          isEditable
        }
        gender {
          value
          isEditable
        }
        streetAndHouseNumber {
          value
          isEditable
        }
        street {
          value
          isEditable
        }
        streetKompareId {
          value
          isEditable
        }
        houseNumber {
          value
          isEditable
        }
        city {
          value
          isEditable
        }
        cityKompareId {
          value
          isEditable
        }
        zipCode {
          value
          isEditable
        }
        oib {
          value
          isEditable
        }
        partnerContactEmail {
          value
          isEditable
        }
      }
      company {
        companyName {
          value
          isEditable
        }
        oib {
          value
          isEditable
        }
        streetAndHouseNumber {
          value
          isEditable
        }
        street {
          value
          isEditable
        }
        houseNumber {
          value
          isEditable
        }
        streetKompareId {
          value
          isEditable
        }
        city {
          value
          isEditable
        }
        cityKompareId {
          value
          isEditable
        }
        zipCode {
          value
          isEditable
        }
        partnerContactEmail {
          value
          isEditable
        }
      }
    }
    delivery {
      asEntity {
        value
        isEditable
      }
      name {
        value
        isEditable
      }
      streetAndHouseNumber {
        value
        isEditable
      }
      street {
        value
        isEditable
      }
      streetKompareId {
        value
        isEditable
      }
      houseNumber {
        value
        isEditable
      }
      city {
        value
        isEditable
      }
      cityKompareId {
        value
        isEditable
      }
      zipCode {
        value
        isEditable
      }
    }
  }
  getTermsAndConditionsFromFiles(id: $offerId) {
    brandName
    brandCode
    logoUrl
    documents {
      fileId
      fileName
    }
  }
  overflowVoucherStatus {
    active
    voucherCode
    voucherValue
    voucherDescription
  }
  personalVoucherStatus(soId: $soId) {
    value
    code
    type
    description
    campaignName
    name
    generatedUniqueCodes
    startDate
    endDate
    status
  }
}
    `;

/**
 * __useCheckoutHealthOfferQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOfferQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useCheckoutHealthOfferQuery(baseOptions: Apollo.QueryHookOptions<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables> & ({ variables: CheckoutHealthOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>(CheckoutHealthOfferDocument, options);
      }
export function useCheckoutHealthOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>(CheckoutHealthOfferDocument, options);
        }
// @ts-ignore
export function useCheckoutHealthOfferSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>): Apollo.UseSuspenseQueryResult<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>;
export function useCheckoutHealthOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>): Apollo.UseSuspenseQueryResult<CheckoutHealthOfferQuery | undefined, CheckoutHealthOfferQueryVariables>;
export function useCheckoutHealthOfferSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>(CheckoutHealthOfferDocument, options);
        }
export type CheckoutHealthOfferQueryHookResult = ReturnType<typeof useCheckoutHealthOfferQuery>;
export type CheckoutHealthOfferLazyQueryHookResult = ReturnType<typeof useCheckoutHealthOfferLazyQuery>;
export type CheckoutHealthOfferSuspenseQueryHookResult = ReturnType<typeof useCheckoutHealthOfferSuspenseQuery>;
export type CheckoutHealthOfferQueryResult = Apollo.QueryResult<CheckoutHealthOfferQuery, CheckoutHealthOfferQueryVariables>;
export const CheckoutHealthOfferDataDocument = gql`
    query checkoutHealthOfferData($offerId: String!) {
  checkoutHealthOfferData(id: $offerId) {
    karenca
    hasPolicy
    newPolicyStartDate
    newPolicyStartDateNote
    productCode
    collectContractorPhone
    insuredPerson {
      firstName {
        value
        isEditable
      }
      lastName {
        value
        isEditable
      }
      birthDate {
        value
        isEditable
      }
      gender {
        value
        isEditable
      }
      streetAndHouseNumber {
        value
        isEditable
      }
      street {
        value
        isEditable
      }
      streetKompareId {
        value
        isEditable
      }
      houseNumber {
        value
        isEditable
      }
      city {
        value
        isEditable
      }
      cityKompareId {
        value
        isEditable
      }
      zipCode {
        value
        isEditable
      }
      oib {
        value
        isEditable
      }
      personalIdNumber {
        value
        isEditable
      }
      personalIdIssuer {
        value
        isEditable
      }
      partnerContactEmail {
        value
        isEditable
      }
    }
    contractor {
      personType
      isSamePerson
      person {
        firstName {
          value
          isEditable
        }
        lastName {
          value
          isEditable
        }
        birthDate {
          value
          isEditable
        }
        gender {
          value
          isEditable
        }
        streetAndHouseNumber {
          value
          isEditable
        }
        street {
          value
          isEditable
        }
        houseNumber {
          value
          isEditable
        }
        streetKompareId {
          value
          isEditable
        }
        city {
          value
          isEditable
        }
        cityKompareId {
          value
          isEditable
        }
        zipCode {
          value
          isEditable
        }
        oib {
          value
          isEditable
        }
        partnerContactEmail {
          value
          isEditable
        }
        phoneNumber {
          value
          isEditable
        }
      }
      company {
        streetAndHouseNumber {
          value
          isEditable
        }
        street {
          value
          isEditable
        }
        houseNumber {
          value
          isEditable
        }
        streetKompareId {
          value
          isEditable
        }
        oib {
          value
          isEditable
        }
        city {
          value
          isEditable
        }
        cityKompareId {
          value
          isEditable
        }
        companyName {
          value
          isEditable
        }
        zipCode {
          value
          isEditable
        }
        partnerContactEmail {
          value
          isEditable
        }
        phoneNumber {
          value
          isEditable
        }
      }
    }
    delivery {
      asEntity {
        value
        isEditable
      }
      name {
        value
        isEditable
      }
      streetAndHouseNumber {
        value
        isEditable
      }
      street {
        value
        isEditable
      }
      streetKompareId {
        value
        isEditable
      }
      houseNumber {
        value
        isEditable
      }
      city {
        value
        isEditable
      }
      cityKompareId {
        value
        isEditable
      }
      zipCode {
        value
        isEditable
      }
    }
  }
}
    `;

/**
 * __useCheckoutHealthOfferDataQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOfferDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOfferDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOfferDataQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCheckoutHealthOfferDataQuery(baseOptions: Apollo.QueryHookOptions<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables> & ({ variables: CheckoutHealthOfferDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>(CheckoutHealthOfferDataDocument, options);
      }
export function useCheckoutHealthOfferDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>(CheckoutHealthOfferDataDocument, options);
        }
// @ts-ignore
export function useCheckoutHealthOfferDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>): Apollo.UseSuspenseQueryResult<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>;
export function useCheckoutHealthOfferDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>): Apollo.UseSuspenseQueryResult<CheckoutHealthOfferDataQuery | undefined, CheckoutHealthOfferDataQueryVariables>;
export function useCheckoutHealthOfferDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>(CheckoutHealthOfferDataDocument, options);
        }
export type CheckoutHealthOfferDataQueryHookResult = ReturnType<typeof useCheckoutHealthOfferDataQuery>;
export type CheckoutHealthOfferDataLazyQueryHookResult = ReturnType<typeof useCheckoutHealthOfferDataLazyQuery>;
export type CheckoutHealthOfferDataSuspenseQueryHookResult = ReturnType<typeof useCheckoutHealthOfferDataSuspenseQuery>;
export type CheckoutHealthOfferDataQueryResult = Apollo.QueryResult<CheckoutHealthOfferDataQuery, CheckoutHealthOfferDataQueryVariables>;
export const GetGeneralTransferPaymentDetailsDocument = gql`
    query GetGeneralTransferPaymentDetails($id: String!, $input: GeneralTransferDetailsInput!) {
  getGeneralTransferPaymentDetails(id: $id, input: $input) {
    price
    customerFirstName
    customerLastName
    customerAddress
    customerCity
    customerZipCode
    customerCountry
    customerPhone
    customerEmail
    customerOib
    recipientName
    recipientAddress
    recipientCity
    recipientZipCode
    recipientAccountNumber
    referenceNumber
    referenceNumberType
    referencePrefix
    referenceSuffix
    model
    description
    numberOfInstallments
  }
}
    `;

/**
 * __useGetGeneralTransferPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetGeneralTransferPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralTransferPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralTransferPaymentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGeneralTransferPaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables> & ({ variables: GetGeneralTransferPaymentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>(GetGeneralTransferPaymentDetailsDocument, options);
      }
export function useGetGeneralTransferPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>(GetGeneralTransferPaymentDetailsDocument, options);
        }
// @ts-ignore
export function useGetGeneralTransferPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>;
export function useGetGeneralTransferPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralTransferPaymentDetailsQuery | undefined, GetGeneralTransferPaymentDetailsQueryVariables>;
export function useGetGeneralTransferPaymentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>(GetGeneralTransferPaymentDetailsDocument, options);
        }
export type GetGeneralTransferPaymentDetailsQueryHookResult = ReturnType<typeof useGetGeneralTransferPaymentDetailsQuery>;
export type GetGeneralTransferPaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetGeneralTransferPaymentDetailsLazyQuery>;
export type GetGeneralTransferPaymentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetGeneralTransferPaymentDetailsSuspenseQuery>;
export type GetGeneralTransferPaymentDetailsQueryResult = Apollo.QueryResult<GetGeneralTransferPaymentDetailsQuery, GetGeneralTransferPaymentDetailsQueryVariables>;
export const CheckoutHealthOfferPaymentOptionsDocument = gql`
    query checkoutHealthOfferPaymentOptions($offerId: String!, $soId: String!) {
  checkoutHealthOfferPaymentOptions(offerId: $offerId) {
    offer {
      status
      brandId
      supplementary {
        label
        brandName
        brandCode
        code
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
        actionLabel
      }
      additional {
        label
        brandName
        brandCode
        code
        total {
          generalTransfer
          generalTransferWithInstallments
          creditCard
          creditCardWithInstallments
        }
      }
    }
    paymentOptions {
      paymentOption
      paymentTypes {
        paymentType
        paymentTypeLabel
        installments {
          installment
          amount
          paymentTypeDiscount
        }
      }
      paymentSlipInfo {
        amount
        numOfInstallments
      }
    }
  }
  checkoutHealthOfferGeneralTransferDetailsOneTime: checkoutHealthOfferGeneralTransferDetails(
    offerId: $offerId
    installments: 1
  ) {
    price
    customerFirstName
    customerLastName
    customerAddress
    customerCity
    customerZipCode
    customerCountry
    customerPhone
    customerEmail
    customerOib
    recipientAccountNumber
    recipientAddress
    recipientCity
    recipientZipCode
    recipientName
    referenceNumber
    referenceNumberType
    referencePrefix
    referenceSuffix
    model
    description
    numberOfInstallments
  }
  checkoutHealthOfferGeneralTransferDetailsInstallments: checkoutHealthOfferGeneralTransferDetails(
    offerId: $offerId
    installments: 12
  ) {
    price
    customerFirstName
    customerLastName
    customerAddress
    customerCity
    customerZipCode
    customerCountry
    customerPhone
    customerEmail
    customerOib
    recipientAccountNumber
    recipientAddress
    recipientCity
    recipientZipCode
    recipientName
    referenceNumber
    referenceNumberType
    referencePrefix
    referenceSuffix
    model
    description
    numberOfInstallments
  }
  checkoutHealthOffer(id: $offerId) {
    _id
    soId
    status
    brandId
    supplementary {
      label
      actionLabel
      brandName
      brandCode
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      voucherPriceChangeModifier {
        amount
        type
        description
        code
      }
      numberOfInstallments
      code
      visual {
        highlight
        tooltip
        description
      }
      logoUrl
      fixedCoverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      coverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      discounts {
        value
        tooltip
      }
      paymentSlipInfo {
        amount
        numOfInstallments
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
    }
    additional {
      label
      brandName
      brandCode
      priceChangeModifier {
        amount
        type
        description
      }
      voucherPriceModifier {
        amount
      }
      numberOfInstallments
      code
      visual {
        highlight
        tooltip
        description
      }
      logoUrl
      coverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      fixedCoverages {
        label
        tooltip
        value
        price
        gratis {
          value
          type
        }
        options {
          key
          value
        }
      }
      discounts {
        value
        tooltip
      }
      total {
        generalTransfer
        generalTransferWithInstallments
        creditCard
        creditCardWithInstallments
      }
    }
    total {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
    annotations
  }
  overflowVoucherStatus {
    active
    voucherCode
    voucherValue
    voucherDescription
  }
  personalVoucherStatus(soId: $soId) {
    value
    code
    type
    description
    campaignName
    name
    generatedUniqueCodes
    startDate
    endDate
    status
  }
}
    `;

/**
 * __useCheckoutHealthOfferPaymentOptionsQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOfferPaymentOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOfferPaymentOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOfferPaymentOptionsQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useCheckoutHealthOfferPaymentOptionsQuery(baseOptions: Apollo.QueryHookOptions<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables> & ({ variables: CheckoutHealthOfferPaymentOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>(CheckoutHealthOfferPaymentOptionsDocument, options);
      }
export function useCheckoutHealthOfferPaymentOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>(CheckoutHealthOfferPaymentOptionsDocument, options);
        }
// @ts-ignore
export function useCheckoutHealthOfferPaymentOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>;
export function useCheckoutHealthOfferPaymentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<CheckoutHealthOfferPaymentOptionsQuery | undefined, CheckoutHealthOfferPaymentOptionsQueryVariables>;
export function useCheckoutHealthOfferPaymentOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>(CheckoutHealthOfferPaymentOptionsDocument, options);
        }
export type CheckoutHealthOfferPaymentOptionsQueryHookResult = ReturnType<typeof useCheckoutHealthOfferPaymentOptionsQuery>;
export type CheckoutHealthOfferPaymentOptionsLazyQueryHookResult = ReturnType<typeof useCheckoutHealthOfferPaymentOptionsLazyQuery>;
export type CheckoutHealthOfferPaymentOptionsSuspenseQueryHookResult = ReturnType<typeof useCheckoutHealthOfferPaymentOptionsSuspenseQuery>;
export type CheckoutHealthOfferPaymentOptionsQueryResult = Apollo.QueryResult<CheckoutHealthOfferPaymentOptionsQuery, CheckoutHealthOfferPaymentOptionsQueryVariables>;
export const GetWsPayPaymentDataDocument = gql`
    query GetWSPayPaymentData($id: String!, $input: GetWspayPaymentDataInput!) {
  getWSPayPaymentData(id: $id, input: $input) {
    ShopID
    ShoppingCartID
    TotalAmount
    Signature
    ReturnURL
    CancelURL
    ReturnErrorURL
    PaymentPlan
    CustomerFirstName
    CustomerLastName
    CustomerAddress
    CustomerCity
    CustomerZIP
    CustomerCountry
    CustomerPhone
    CustomerEmail
    PaymentMethod
    Iframe
    IframeResponseTarget
    Version
  }
}
    `;

/**
 * __useGetWsPayPaymentDataQuery__
 *
 * To run a query within a React component, call `useGetWsPayPaymentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWsPayPaymentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWsPayPaymentDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetWsPayPaymentDataQuery(baseOptions: Apollo.QueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables> & ({ variables: GetWsPayPaymentDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>(GetWsPayPaymentDataDocument, options);
      }
export function useGetWsPayPaymentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>(GetWsPayPaymentDataDocument, options);
        }
// @ts-ignore
export function useGetWsPayPaymentDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>;
export function useGetWsPayPaymentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetWsPayPaymentDataQuery | undefined, GetWsPayPaymentDataQueryVariables>;
export function useGetWsPayPaymentDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>(GetWsPayPaymentDataDocument, options);
        }
export type GetWsPayPaymentDataQueryHookResult = ReturnType<typeof useGetWsPayPaymentDataQuery>;
export type GetWsPayPaymentDataLazyQueryHookResult = ReturnType<typeof useGetWsPayPaymentDataLazyQuery>;
export type GetWsPayPaymentDataSuspenseQueryHookResult = ReturnType<typeof useGetWsPayPaymentDataSuspenseQuery>;
export type GetWsPayPaymentDataQueryResult = Apollo.QueryResult<GetWsPayPaymentDataQuery, GetWsPayPaymentDataQueryVariables>;
export const CheckoutHealthOffersDocument = gql`
    query checkoutHealthOffers($soId: String!) {
  checkoutHealthOffers(id: $soId) {
    _id
    soId
    brandId
    status
    paidAt
    isPublished
    annotations
    termsAcceptedAt
    iddTermsAcceptedAt
    allianzGDPRAcceptedAt
    acceptedEmailDocumentationDeliveryAt
    supplementary {
      label
      code
      brandName
      brandCode
      logoUrl
      numberOfInstallments
      baseProductPrice
      actionLabel
      includedInPrice {
        label
        description
      }
      additionalCoverages {
        label
        description
      }
    }
    additional {
      label
      code
      brandName
      brandCode
      logoUrl
      numberOfInstallments
      baseProductPrice
    }
    total {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
  }
}
    `;

/**
 * __useCheckoutHealthOffersQuery__
 *
 * To run a query within a React component, call `useCheckoutHealthOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutHealthOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutHealthOffersQuery({
 *   variables: {
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useCheckoutHealthOffersQuery(baseOptions: Apollo.QueryHookOptions<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables> & ({ variables: CheckoutHealthOffersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>(CheckoutHealthOffersDocument, options);
      }
export function useCheckoutHealthOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>(CheckoutHealthOffersDocument, options);
        }
// @ts-ignore
export function useCheckoutHealthOffersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>): Apollo.UseSuspenseQueryResult<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>;
export function useCheckoutHealthOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>): Apollo.UseSuspenseQueryResult<CheckoutHealthOffersQuery | undefined, CheckoutHealthOffersQueryVariables>;
export function useCheckoutHealthOffersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>(CheckoutHealthOffersDocument, options);
        }
export type CheckoutHealthOffersQueryHookResult = ReturnType<typeof useCheckoutHealthOffersQuery>;
export type CheckoutHealthOffersLazyQueryHookResult = ReturnType<typeof useCheckoutHealthOffersLazyQuery>;
export type CheckoutHealthOffersSuspenseQueryHookResult = ReturnType<typeof useCheckoutHealthOffersSuspenseQuery>;
export type CheckoutHealthOffersQueryResult = Apollo.QueryResult<CheckoutHealthOffersQuery, CheckoutHealthOffersQueryVariables>;
export const CrossSellAdditionalInfoDocument = gql`
    query crossSellAdditionalInfo($offerId: String!) {
  hasActiveAdditionalHealthPolicy(id: $offerId)
  overflowVoucherStatus {
    active
    voucherCode
    voucherValue
    voucherDescription
  }
  checkoutHealthOfferData(id: $offerId) {
    contractor {
      person {
        firstName {
          value
        }
        lastName {
          value
        }
        birthDate {
          value
        }
        phoneNumber {
          value
        }
        partnerContactEmail {
          value
        }
      }
    }
    insuredPerson {
      firstName {
        value
      }
      lastName {
        value
      }
      birthDate {
        value
      }
      partnerContactEmail {
        value
      }
    }
  }
}
    `;

/**
 * __useCrossSellAdditionalInfoQuery__
 *
 * To run a query within a React component, call `useCrossSellAdditionalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrossSellAdditionalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrossSellAdditionalInfoQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCrossSellAdditionalInfoQuery(baseOptions: Apollo.QueryHookOptions<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables> & ({ variables: CrossSellAdditionalInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>(CrossSellAdditionalInfoDocument, options);
      }
export function useCrossSellAdditionalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>(CrossSellAdditionalInfoDocument, options);
        }
// @ts-ignore
export function useCrossSellAdditionalInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>): Apollo.UseSuspenseQueryResult<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>;
export function useCrossSellAdditionalInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>): Apollo.UseSuspenseQueryResult<CrossSellAdditionalInfoQuery | undefined, CrossSellAdditionalInfoQueryVariables>;
export function useCrossSellAdditionalInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>(CrossSellAdditionalInfoDocument, options);
        }
export type CrossSellAdditionalInfoQueryHookResult = ReturnType<typeof useCrossSellAdditionalInfoQuery>;
export type CrossSellAdditionalInfoLazyQueryHookResult = ReturnType<typeof useCrossSellAdditionalInfoLazyQuery>;
export type CrossSellAdditionalInfoSuspenseQueryHookResult = ReturnType<typeof useCrossSellAdditionalInfoSuspenseQuery>;
export type CrossSellAdditionalInfoQueryResult = Apollo.QueryResult<CrossSellAdditionalInfoQuery, CrossSellAdditionalInfoQueryVariables>;
export const SoPartnerDocument = gql`
    query soPartner($soId: String!) {
  soPartner(soId: $soId) {
    code
    name
  }
}
    `;

/**
 * __useSoPartnerQuery__
 *
 * To run a query within a React component, call `useSoPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoPartnerQuery({
 *   variables: {
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useSoPartnerQuery(baseOptions: Apollo.QueryHookOptions<SoPartnerQuery, SoPartnerQueryVariables> & ({ variables: SoPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoPartnerQuery, SoPartnerQueryVariables>(SoPartnerDocument, options);
      }
export function useSoPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoPartnerQuery, SoPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoPartnerQuery, SoPartnerQueryVariables>(SoPartnerDocument, options);
        }
// @ts-ignore
export function useSoPartnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SoPartnerQuery, SoPartnerQueryVariables>): Apollo.UseSuspenseQueryResult<SoPartnerQuery, SoPartnerQueryVariables>;
export function useSoPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SoPartnerQuery, SoPartnerQueryVariables>): Apollo.UseSuspenseQueryResult<SoPartnerQuery | undefined, SoPartnerQueryVariables>;
export function useSoPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SoPartnerQuery, SoPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoPartnerQuery, SoPartnerQueryVariables>(SoPartnerDocument, options);
        }
export type SoPartnerQueryHookResult = ReturnType<typeof useSoPartnerQuery>;
export type SoPartnerLazyQueryHookResult = ReturnType<typeof useSoPartnerLazyQuery>;
export type SoPartnerSuspenseQueryHookResult = ReturnType<typeof useSoPartnerSuspenseQuery>;
export type SoPartnerQueryResult = Apollo.QueryResult<SoPartnerQuery, SoPartnerQueryVariables>;
export const GetCalculationsDocument = gql`
    query getCalculations($input: CalculationRequestInput!, $soId: String!) {
  getCalculations(input: $input, soId: $soId) {
    code
    brandName
    actionLabel
    label
    priceWithoutDiscounts
    diffPrice
    prices {
      generalTransfer
      generalTransferWithInstallments
      creditCard
      creditCardWithInstallments
    }
    fixedCoverages {
      code
      label
      description
      tooltip
    }
    coverages {
      code
      label
      description
      tooltip
      editOnWeb
      price
    }
    visual {
      highlight
      discount
      tooltip
      description
    }
    logoUrl
  }
  overflowVoucherStatus {
    active
    voucherCode
    voucherValue
    voucherDescription
  }
  personalVoucherStatus(soId: $soId) {
    value
    code
    type
    description
    campaignName
    name
    generatedUniqueCodes
    startDate
    endDate
    status
  }
}
    `;

/**
 * __useGetCalculationsQuery__
 *
 * To run a query within a React component, call `useGetCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalculationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useGetCalculationsQuery(baseOptions: Apollo.QueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables> & ({ variables: GetCalculationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalculationsQuery, GetCalculationsQueryVariables>(GetCalculationsDocument, options);
      }
export function useGetCalculationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalculationsQuery, GetCalculationsQueryVariables>(GetCalculationsDocument, options);
        }
// @ts-ignore
export function useGetCalculationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalculationsQuery, GetCalculationsQueryVariables>;
export function useGetCalculationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCalculationsQuery | undefined, GetCalculationsQueryVariables>;
export function useGetCalculationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCalculationsQuery, GetCalculationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCalculationsQuery, GetCalculationsQueryVariables>(GetCalculationsDocument, options);
        }
export type GetCalculationsQueryHookResult = ReturnType<typeof useGetCalculationsQuery>;
export type GetCalculationsLazyQueryHookResult = ReturnType<typeof useGetCalculationsLazyQuery>;
export type GetCalculationsSuspenseQueryHookResult = ReturnType<typeof useGetCalculationsSuspenseQuery>;
export type GetCalculationsQueryResult = Apollo.QueryResult<GetCalculationsQuery, GetCalculationsQueryVariables>;
